import React, { Component } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Button, IconButton } from "@mui/material";
import { FormControl } from "@mui/material";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import MoreOptions from "./moreOptions";
import settings from "../helpers/Settings";
import Row from "react-bootstrap/Row";
import Cookies from "js-cookie";
import Col from "react-bootstrap/Col";
import axios from "axios";
import { Box } from "@mui/material";
import * as moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CircularProgress from "@mui/material/CircularProgress";
import InputLabel from "@mui/material/InputLabel";
import Select, { selectClasses } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Accordion from "react-bootstrap/Accordion";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import Autocomplete from "./AutoCompleteComponent/AutoComplete";
import AutoComplete from "@mui/material/Autocomplete";
import { Multiselect } from "multiselect-react-dropdown";
import Checkbox from "@mui/material/Checkbox";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ReplyIcon from "@mui/icons-material/Reply";
let { KayanURL } = settings;
const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  borderRadius: "20px",
  p: 4,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
const allTPA = {
  7001463160: "GlobeMed Saudi",
  7001580856: "Nextcare",
  7001604342: "Mednet",
  7001599658: "Totalcare",
};
const allInsuraceCompanies = {
  "INS-FHIR": "Pseudo Payer",
  7001571327: "Bupa Arabia for Cooperative Insurance",
  7000911508: "The Cooperative Company for Cooperative Insurance",
  7001593321: "Al-Rajhi Company for Cooperative Insurance",
  7001548317:
    "The Mediterranean and Gulf Cooperative Insurance and Reinsurance Company (MedGulf)",
  7001539720: "Saudi Arabian Cooperative Insurance Company (SAICO) *",
  7001532279: "Gulf Union Cooperative Insurance Company",
  7001607683: "AXA Cooperative Insurance Company",
  7001519912: "Malath Cooperative Insurance and Reinsurance Company",
  7001559389: "United Cooperative Insurance Company",
  7001727200: "Tokyo Marine Development Corporation",
  7001527816: "Arabian Shield Cooperative Insurance Company *",
  7001617724: "Buruj Cooperative Insurance Company *",
  7001549059: "Trade Union Cooperative Insurance Company *",
  7001544472: "Al Sagr Cooperative Insurance Company *",
  7001641419: "Gulf General Company for Cooperative Insurance",
  7001609481: "Global Company for Cooperative Insurance",
  7001535694: "Allied Cooperative Insurance Group (ACIG)",
  7001526578: "Saudi United Cooperative Insurance Company (Wala",
  7001537161: "Allianz Saudi Fransi Cooperative Insurance Company",
  7001534275: "The National Company for Cooperative Insurance",
  7001626717: "Amana Cooperative Insurance Company *",
  7001625891: "Solidarity Saudi Takaful Company",
  7001703672: "Saudi Enaya Cooperative Insurance Company",
  7001523724: "Salama Cooperative Insurance Company",
  7001527667: "Arabia Insurance Cooperative Company",
};
class PreAuthorization extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      searchDefaultValue: "",
      visitstartdateError: false,
      vitalSignsArray: [],
      vitalSignSelectArray: [],
      visitstartdate: null,
      allDiagnosisSelect: [],
      editClaim: false,
      procedureQuantity: 1,
      procedureShare: 0,
      serviceValue: "",
      autoValue: "",
      diagnosisSequence: [],
      informationSequence: [],
      calimDefaultValue: "",
      proceduresForResubmission: [],
      proceduresSeq: [],
      checkAll: false,
      authLoading: false,
      cancelLoading: false,
      statusLoading: false,
      saveLoading: false,
      resubmissionLoading: false,
      re_resubmissionFlagLoading: false,
      pollLoading: false,
      selectedProcedures: [],
      selectAll: false,
      queuedInfo: {},
      key: 0,
      diagKey: 0,
      procedure: {},
      pollCommLoading: false,
    };
  }
  componentDidMount = async () => {
    let nphiesID = localStorage.getItem("nphies-id");
    this.setState({ nphiesID });
    this.getAllVisits();
    this.getAllDiagnosis();
  };
  getAllAuthInfo = async () => {
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getAllAuthInfo",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (result) {
      let { data } = result;
      if (data) {
        if (data.success) {
          console.log(data.allAuth, "auth for map");
          this.setState({
            success: true,
            allAuthInfo: data.allAuth,
          });
          this.getAllCommRequestInfo();
        } else {
          this.setState({
            success: false,
            error: data.error,
          });
        }
      }
    }
  };
  getAllCommRequestInfo = async () => {
    let { allAuthInfo } = this.state;
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getAllCommunicationRequest",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (result) {
      let { data } = result;
      if (data) {
        let { allCommRequest } = data;
        if (data.success) {
          console.log(data.allCommRequest, "commm for map");
          if (allCommRequest && allCommRequest.length > 0) {
            if (allAuthInfo && allAuthInfo.length > 0) {
              for (let i = 0; i < allAuthInfo.length; i++) {
                let obj = allCommRequest.find(
                  (e) =>
                    e.communicationabout ==
                    allAuthInfo[i].authorizationrequestidentifier
                );
                if (obj) {
                  this.setState({ commRequestExist: true });
                }
              }
            }
          }

          this.setState({
            success: true,
            allCommRequestInfo: data.allCommRequest,
          });
        } else {
          this.setState({
            success: false,
            error: data.error,
          });
        }
      }
    }
  };
  onFileChange = async (e) => {
    this.setState({ selectedFile: e.target.files[0] });
    const allowedExtensions = ["pdf"];
    const fileExtension = e.target.files[0].name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.setState({
        fileMsg: "Please select a PDF file.",
      });
    } else {
      this.setState({ fileMsg: "" });
      let res = await this.readContent(e.target.files[0]);
      this.setState({
        vitalSignJson: {
          display: "attachment",
          valueInfo: e.target.files[0],
          data: res,
        },
        vitalSignSelectJson: {
          display: "attachment" + " " + e.target.files[0].name,
          valueInfo: e.target.files[0].name,
        },
        vitalValue: e.target.files[0].name,
        selectedName: "attachment",
      });
    }
  };
  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({
      [name]: value,
      calimDefaultValue: value,
    });
  };
  handleCheckBox = async (e, index) => {
    let { visitNeedApproval, proceduresForResubmission, proceduresSeq } =
      this.state;
    let procedureselected;
    if (e.target.name === "selectAllProcedure") {
      if (e.target.checked) {
        proceduresForResubmission.splice(0, proceduresForResubmission.length);
        proceduresSeq.splice(0, proceduresSeq.length);
        proceduresForResubmission = [...visitNeedApproval["allprocedures"]];
        for (let i = 0; i < proceduresForResubmission.length; i++) {
          proceduresSeq.push(i + 1);
        }
        this.setState({
          proceduresForResubmission,
          proceduresSeq,
          // checkAll: true,
        });
        // console.log(proceduresForResubmission,proceduresSeq ,'sseq')
      } else {
        this.setState({
          proceduresForResubmission: [],
          proceduresSeq: [],
          // checkAll: false
        });
      }
    } else if (e.target.name === "selectProcedure") {
      if (e.target.checked) {
        procedureselected = visitNeedApproval["allprocedures"].find(
          (item) => visitNeedApproval["allprocedures"].indexOf(item) === index
        );
        proceduresForResubmission.push(procedureselected);
        proceduresSeq.push(
          visitNeedApproval["allprocedures"].indexOf(procedureselected) + 1
        );
        // console.log(proceduresSeq, 'sseq')
        this.setState({
          proceduresForResubmission,
          proceduresSeq,
        });
      } else {
        console.log("hooooooon");
        let i = proceduresSeq.indexOf(index + 1);
        // console.log(visitNeedApproval["allprocedures"][index])
        // console.log(proceduresForResubmission.indexOf(proceduresForResubmission[proceduresForResubmission.indexOf(visitNeedApproval["allprocedures"][index])]), 'delete')
        proceduresForResubmission.splice(
          proceduresForResubmission.indexOf(
            proceduresForResubmission[
            proceduresForResubmission.indexOf(
              visitNeedApproval["allprocedures"][index]
            )
            ]
          ),
          1
        );
        proceduresSeq.splice(i, 1);
        this.setState({
          proceduresForResubmission,
          proceduresSeq,
        });
      }
    } else {
      if (e.target.checked) {
        visitNeedApproval["diagnosis"][index].onAdmission = true;
      }
    }
  };
  readContent = async (files) => {
    let fileReader = new FileReader();
    let fileToLoad = files;
    let file = "";
    return new Promise((resolve, reject) => {
      fileReader.onload = async (fileLoadedEvent) => {
        file = fileLoadedEvent.target.result;
        resolve(file.split(",")[1]);
      };
      fileReader.readAsDataURL(fileToLoad);
    });
  };
  getAllAuthorizationInfo = async (visit) => {
    let { allDiagnosisSelect, vitalSignSelectArray, calimDefaultValue } =
      this.state;
    calimDefaultValue = visit.claimtype;
    this.setState({ calimDefaultValue });
    let { doctorid } = visit;

    if (doctorid) {
      let doctor = await this.getDoctorByID(doctorid);

      if (doctor && doctor.length > 0) {
        doctor = doctor[0];
        let { name } = doctor;
        visit["doctorName"] = name;
      }
      if (allDiagnosisSelect.length == 0) {
        let allDiagnosisArray = visit.diagnosis;
        for (let i = 0; i < allDiagnosisArray.length; i++) {
          allDiagnosisSelect.push({
            view: allDiagnosisArray[i].type + " " + allDiagnosisArray[i].code,
          });
        }
      }
      if (
        visit.supportinginformation &&
        visit.supportinginformation.length > 0 &&
        vitalSignSelectArray.length == 0
      ) {
        let categories = visit.supportinginformation;
        for (let i = 0; i < categories.length; i++) {
          let display = Object.keys(categories[i]);
          let valueInfo = Object.values(categories[i]);
          if (display[0] === "chief-complaint") {
            valueInfo = Object.values(categories[i])[0].text;
          } else if (display[0] === "attachment") {
            valueInfo = Object.values(categories[i])[0].title;
          }
          vitalSignSelectArray.push({
            display: display[0] + " " + valueInfo,
            valueInfo: valueInfo,
          });
        }
      }
    }
    //if the preauth status of the claim not pending (not equal 1 7)
    // if (visit && visit["authorizationstatus"] == "1") {
    console.log("just show the original info");
    this.setState({
      viewPreAuthInfoModal: true,
      authitemsRows: [],
      allproceduresRows: [],
      errorsRow: [],
      visitNeedApproval: visit,
      queuedInfo: {},
      queuedInfoFlag: false,
      AllAprovalForResubmission:[]
    });

    let result = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getAllAuthInfoByVisitID",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        visitId: visit.id,
      }
    );

    if (result) {
      let { data } = result;
      if (data) {
        if (data.success) {
          let { AllApproval } = data;
          console.log(AllApproval,'allApp by visitid')
          let ApprovalInfo;
          if (AllApproval && AllApproval.length > 0) {
            ApprovalInfo = AllApproval.find(
              (visit) => visit.type === "Authorization"
            );
            this.setState({
              success: true,
              visitNeedApproval: visit,
            });

            let {
              authorizationresponseoutcome,
              authorizationrequestidentifier,
              authorizationresponseidentifier,
              authorizationrequestbundleid,
              preauthperiod,
              preauthref,
              totals,
            } = ApprovalInfo;
             console.log(ApprovalInfo,'appppppppppppAuth')
            if (authorizationresponseoutcome === "complete") {
              visit["authorizationRequestIdentifier"] =
                authorizationrequestidentifier;

              visit["authorizationResponseIdentifier"] =
                authorizationresponseidentifier;

              visit["authorizationRequestBundleID"] =
                authorizationrequestbundleid;
              visit["preAuthRef"] = preauthref;
              visit["preAuthPeriod"] = preauthperiod;
              visit["totals"] = totals;

              let { items, adjucationoutcome } = ApprovalInfo;

              visit["adjucationoutcome"] = adjucationoutcome;

              if (items && items.length > 0) {
                let { allprocedures } = visit;
                  // console.log(allprocedures,)
                items.forEach((item, index) => {
                  let { outcome, adjudications, reason, denailCode } = item;

                  allprocedures[index]["outcome"] = outcome;
                  allprocedures[[index]]["adjudications"] = adjudications;

                  if (outcome == "rejected" || outcome == "partial") {
                    allprocedures[[index]]["reason"] = reason;
                    allprocedures[[index]]["denailCode"] = denailCode;
                  }

                  visit["allprocedures"] = allprocedures;
                });

                this.setState({
                  visitNeedApproval: visit,
                  viewPreAuthInfoModal: true,
                });

                // this.setState({ authitemsRows, adjucationoutcome });
              }
            } else if (authorizationresponseoutcome === "error") {
              visit["authorizationRequestIdentifier"] =
                authorizationrequestidentifier;

              visit["authorizationResponseIdentifier"] =
                authorizationresponseidentifier;

              let { autherror } = ApprovalInfo;
              if (autherror && autherror.length > 0) {
                const errorsRow = autherror.map((element, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.code}
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.display}
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.extension}
                      </TableCell>
                    </TableRow>
                  );
                });
                this.setState({
                  errorsRow,
                  visitNeedApproval: visit,
                });
              }
            } else if (authorizationresponseoutcome === "queued") {
              visit["authorizationRequestIdentifier"] =
                authorizationrequestidentifier;

              visit["authorizationResponseIdentifier"] =
                authorizationresponseidentifier;
              this.setState({
                queuedInfoFlag: true,
                queuedInfo: {
                  outcome: ApprovalInfo.authorizationresponseoutcome,
                  bundleID: ApprovalInfo.authorizationrequestbundleid,
                  requestIdentifier:
                    ApprovalInfo.authorizationrequestidentifier,
                  preAuthResponseIdentifier:
                    ApprovalInfo.authorizationresponseidentifier,
                },
                visitNeedApproval: visit,
              });
            }
            AllApproval.splice(AllApproval.indexOf(ApprovalInfo), 1);
            console.log(AllApproval, 'allApp after')
            if (AllApproval && AllApproval.length > 0) {
              let AllAprovalForResubmission = [];
              for (let i = 0; i < AllApproval.length; i++) {
                let ApprovalForResubmission = AllApproval[i];
                let procedures = [];
                let {
                  authorizationresponseoutcome,
                  authorizationrequestidentifier,
                  authorizationresponseidentifier,
                  authorizationrequestbundleid,
                  preauthperiod,
                  preauthref,
                  totals,
                  proceduresequenses,
                } = AllApproval[i];

                let { allprocedures, diagnosis, supportinginformation } = visit;

                if (proceduresequenses && proceduresequenses.length > 0) {
                  for (let i = 0; i < proceduresequenses.length; i++) {
                    let index = proceduresequenses[i] - 1;
                    procedures.push(allprocedures[index]);
                  }
                  // console.log(procedures)
                  ApprovalForResubmission["allprocedures"] = procedures;
                  ApprovalForResubmission["diagnosis"] = diagnosis;
                  ApprovalForResubmission["supportinginformation"] =
                    supportinginformation;
                }
                if (authorizationresponseoutcome === "complete") {
                  ApprovalForResubmission["preAuthRef"] = preauthref;
                  ApprovalForResubmission["preAuthPeriod"] = preauthperiod;
                  ApprovalForResubmission["totals"] = totals;

                  let { items, adjucationoutcome } = AllApproval[i];

                  ApprovalForResubmission["adjucationoutcome"] =
                    adjucationoutcome;

                  if (items && items.length > 0) {
                    items.forEach((item, index) => {
                      let { outcome, adjudications, reason, denailCode } = item;

                      procedures[[index]]["outcome"] = outcome;
                      procedures[[index]]["adjudications"] = adjudications;

                      if (outcome == "rejected" || outcome == "partial") {
                        procedures[[index]]["reason"] = reason;
                        procedures[[index]]["denailCode"] = denailCode;
                      }
                    });

                    ApprovalForResubmission["allprocedures"] = procedures;
                    // this.setState({ authitemsRows, adjucationoutcome });
                  }
                } else if (authorizationresponseoutcome === "error") {
                  let { autherror } = AllApproval[i];
                  if (autherror && autherror.length > 0) {
                    const errorsRow = autherror.map((element, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell
                            align="center"
                            style={{ fontSize: "small" }}
                          >
                            {element.code}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: "small" }}
                          >
                            {element.display}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: "small" }}
                          >
                            {element.extension}
                          </TableCell>
                        </TableRow>
                      );
                    });
                    ApprovalForResubmission["errorsRow"] = errorsRow;
                    // this.setState({ errorsRow });
                  }
                } else if (authorizationresponseoutcome === "queued") {
                  console.log("queued", ApprovalInfo);

                  ApprovalForResubmission["queuedInfo"] = {
                    outcome: authorizationresponseoutcome,
                    bundleID: authorizationrequestbundleid,
                    requestIdentifier: authorizationrequestidentifier,
                    preAuthResponseIdentifier: authorizationresponseidentifier,
                  };
                }
                AllAprovalForResubmission.push(ApprovalForResubmission);
              }

              AllAprovalForResubmission.sort((a, b) => a.id - b.id);
              console.log(AllAprovalForResubmission, "allResub");

              this.setState({ AllAprovalForResubmission });
            }
          }
        }
      }
      // }
    }

    this.setState({
      viewPreAuthInfoModal: true,
      allproceduresRows: [],
      authitemsRows: [],
    });
  };
  getDoctorByID = async (id) => {
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/employee/getDoctorByID",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        doctorID: id,
      }
    );
    if (result) {
      let { data } = result;
      if (data) {
        let { doctor } = data;
        // if (data.success) {
        return doctor;
        // }
      }
    }
  };
  getAllVisits = async () => {
    this.setState({ getAllVisitRequestSent: true });
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getAllVisistsForInsurance",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (result) {
      this.setState({ getAllVisitRequestSent: false });

      let { data } = result;
      if (data) {
        if (data.success) {
          await this.getAllAuthInfo();
          this.setState({
            success: true,
            allvisits: data.visits,
            requestsFound: false,
          });
        } else {
          this.setState({
            success: false,
            error: data.error,
            allvisits: data.visit,
          });
        }
      }
    }

    console.log("all visits", this.state.allvisits);
  };
  AuthorizationRequest = async (e, visit) => {
    e.preventDefault();
    this.setState({ authErrorMsg: "", authLoading: true });
    let coverageInfo;
    let doctor = [];
    let doctorLastName = "";
    let doctorName;
    if (visit) {
      let { selectedinsurance, doctorid } = visit;
      if (doctorid) {
        doctor = await this.getDoctorByID(doctorid);
        doctorName = doctor[0]["name"].split(" ");
        for (let i = 1; i < doctorName.length; i++) {
          doctorLastName += doctorName[i] + " ";
        }
      }
      if (selectedinsurance && selectedinsurance.length > 0) {
        let { coverage } = selectedinsurance[0];
        let { paymentDetails } = coverage[0];
        let cost = [];
        if (paymentDetails && paymentDetails.length > 0) {
          for (let i = 0; i < paymentDetails.length; i++) {
            let keys = Object.keys(paymentDetails[i]);
            if (keys[0] === "spvisit") {
              let valueOfKey = paymentDetails[i][keys];
              cost.push({ [keys]: valueOfKey.toString() });
            } else {
              let valueOfKey = paymentDetails[i][keys].split(" ")[0];
              cost.push({ [keys]: valueOfKey });
            }
          }
        }

        coverageInfo = {
          class: coverage[0].class,
          "coverage-type": coverage[0]["coverage-type"],
          memberid: coverage[0].memberid,
          network: coverage[0].network,
          period: coverage[0].period,
          "subscriber-relationship": coverage[0]["subscriber-relationship"],
          paymentDetails: cost,
        };
      }
    }
    // let related = resubmissionFlag ? visit.authorizationRequestIdentifier : "";

    let CheckAuthorizationResponse = await axios.post(
      // KayanURL + "api/KSA/RCM/request",
      "http://141.147.130.248:4000/api/KSA/RCM/request",
      {
        apiToken: "token",
        requestType: "2",
        payerID: visit.payerid ? visit.payerid : "",
        TPA: visit.tpa ? visit.tpa : "",
        payerName: visit.payername,
        providerName: localStorage.getItem("nphies-provider-name"),
        providerID: localStorage.getItem("nphies-id"),
        providerType: 1,

        patient: {
          ID: visit.identifier,
          firstName: visit["firstname"],
          lastName: visit["lastname"],
          phone: visit["phone"],
          gender: visit["gender"],
          birthDate: visit["birthdate"],
          identifierType: visit["identifiertype"],
          maritalStatus: "U",
          occupation: "business"
        },

        //this should be from database
        doctor: {
          firstName: doctorName[0],
          lastName: doctorLastName,
          practiceCode: doctor[0].doctor_practice_code,
          license: doctor[0].doctor_license,
        },
        codingSystem: "internal",
        related: "",
        supportingInformation:/*  visit.supportinginformation */[
          {
            "reason-for-visit": "new-visit"
          },
          {
            "vital-sign-systolic": "100"
          },
          {
            "vital-sign-diastolic": "60"
          },
          {
            "vital-sign-height": "160"
          },
          {
            "vital-sign-weight": "60"
          },
          {
            "pulse": "85"
          },
          {
            "respiratory-rate": "15"
          },
          {
            "chief-complaint": {
              "text": "LOWER ABDOMINAL PAIN, LOSS OF WEIGHT  6 KG, LOSS OF APPETITE, ALTERNATIVE DIARRHEA AND CONSTIPATION, ABDOMINAL DISCOMFORT, FLATULENCE,  BACK PAIN, HEART BURN AFTER EATING, AGGREVATED BY RECUMBENCY, RELIEVED WITH SITTING, ASSOCITED WITH ACID REGURGITATION",
              "ICD": "A00.0"
            }
          },
          {
            "temperature": "37.5"
          },
          {
            "estimated-Length-of-Stay": 2
          },
          {
            "oxygen-saturation": "5"
          },
          {
            "investigation-result": "INP"
          },
          {
            "treatment-plan": "Appendectomy"
          },
          {
            "patient-history": "No systemic disease"
          },
          {
            "physical-examination": "Stable"
          },
          {
            "history-of-present-illness": "No history"
          }
        ],
        claimType: visit.claimtype,
        diagnosis: visit.diagnosis,

        procedures: visit.allprocedures,
        coverage: coverageInfo,
        transfer: visit.istransfer,
        newborn: visit.isnewborn,
        testing:
          /* nphiesID === "10000300178702" ? true : false, */ visit.payerid ===
            "INS-FHIR"
            ? true
            : false,
        claimSubType: "op",
        returnFullResponse: false,
        "encounter": {
          "ID": "123456",
          "status": "finished",
          "class": {
            "code": "AMB",
            "display": "Ambulatory"
          },
          "admitSource": "WKIN",
          "serviceEventType": "ICSE",
          "period": {
            "start": "2024-07-11T10:25:00+03:00",
            // "end": "2024-07-13T10:25:00+03:00"
          },
          "serviceProvider": {
            "ID": "10000300178702",
            "name": "Faraby"
          },
          "patientID": "2013456789"
        }
      }
    );
       
    if (CheckAuthorizationResponse) {
      // if (!resubmissionFlag) {
      setTimeout(() => {
        this.setState({ authLoading: false });
      }, 500);
      // }

      let { data } = CheckAuthorizationResponse;
      if (data) {
        let {
          success,
          response,
          error,
          BundleID,
          PreAuthPeriod,
          items,
          Total,
          preAuthResponseIdentifier,
          adjudicationOutcome,
          requestIdentifier,
          preAuthRef,
          outcome,
        } = data;
        console.log("auth response", data);
        let updateVisit;
        if (success) {
          this.setState({ success: true /*  BundleID */, outcome });

          if (outcome === "complete") {
            //update the authorization response of the visit
            updateVisit = await this.handleAddPreAuthResponse(
              items,
              Total,
              preAuthResponseIdentifier,
              BundleID,
              adjudicationOutcome,
              outcome,
              requestIdentifier,
              preAuthRef,
              visit["id"],
              [],
              PreAuthPeriod,
              "",
              null
            );
            this.getAllAuthorizationInfo(updateVisit);
          } else if (outcome === "queued") {
            updateVisit = await this.handleAddPreAuthResponse(
              [],
              [],
              preAuthResponseIdentifier,
              BundleID,
              "",
              outcome,
              requestIdentifier,
              "",
              visit["id"],
              [],
              {},
              "",
              null
            );
            this.getAllAuthorizationInfo(updateVisit);
          }
        } else {
          if (outcome && outcome === "error") {
            updateVisit = await this.handleAddPreAuthResponse(
              [],
              [],
              preAuthResponseIdentifier,
              BundleID,
              "",
              outcome,
              requestIdentifier,
              "",
              visit["id"],
              error,
              {},
              "",
              null
            );

            this.getAllAuthorizationInfo(updateVisit);
          } else {
            console.log(error, "error");
            this.setState({ authErrorMsg: error });
            console.log("not success");
          }
        }
      }
    }
    // this.setState({ resubmissionFlag: false });
  };
  getProcedures = async (id) => {
    let procedures = [];
    let Response = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getAuthByID",
      {
        authId: id,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      console.log(data, "authId");
      if (data) {
        if (data.success) {
          console.log(data.AllApproval[0], "all");
          if (data.AllApproval && data.AllApproval.length > 0) {
            let { proceduresequenses } = data.AllApproval[0];
            // related = data.AllApproval[0].related;
            // console.log(related)
            let { allprocedures } = this.state.visitNeedApproval;
            this.setState({ proceduresSeq: proceduresequenses });
            if (proceduresequenses && proceduresequenses.length > 0) {
              for (let i = 0; i < proceduresequenses.length; i++) {
                let index = proceduresequenses[i] - 1;
                procedures.push(allprocedures[index]);
              }
              this.setState({
                proceduresForResubmission: procedures,
                proceduresSeq: proceduresequenses,
              });
              // // console.log(procedures)
            }
          }
        } else {
          console.log(
            "error in update or add the authorization response of a visit:",
            data.error
          );
          this.setState({ success: false /* , error: data.error */ });
        }
      }
    }
  };
  ReAuthorizationRequest = async (e, visit, id) => {
    e.preventDefault();
    // console.log(visit["PrevRelated"], "prev")
    let { proceduresForResubmission } = this.state;
    this.setState({
      resubmissionLoading: !id ? true : false,
      re_resubmissionFlagLoading: id ? true : false,
    });
    // let procedures = []
    // let related

    this.setState({ authErrorMsg: "" });
    console.log("selected visit", visit);
    let related = visit["PrevRelated"]
      ? visit["PrevRelated"]
      : visit["authorizationRequestIdentifier"];
    let coverageInfo;
    let doctor = [];
    let doctorLastName = "";
    let doctorName;
    if (visit) {
      let { selectedinsurance, doctorid } = visit;
      if (doctorid) {
        doctor = await this.getDoctorByID(doctorid);
        doctorName = doctor[0]["name"].split(" ");
        for (let i = 1; i < doctorName.length; i++) {
          doctorLastName += doctorName[i] + " ";
        }
      }
      if (selectedinsurance && selectedinsurance.length > 0) {
        let { coverage } = selectedinsurance[0];
        let { paymentDetails } = coverage[0];
        let cost = [];
        if (paymentDetails && paymentDetails.length > 0) {
          for (let i = 0; i < paymentDetails.length; i++) {
            let keys = Object.keys(paymentDetails[i]);
            if (keys[0] === "spvisit") {
              let valueOfKey = paymentDetails[i][keys];
              cost.push({ [keys]: valueOfKey.toString() });
            } else {
              let valueOfKey = paymentDetails[i][keys].split(" ")[0];
              cost.push({ [keys]: valueOfKey });
            }
          }
        }

        coverageInfo = {
          class: coverage[0].class,
          "coverage-type": coverage[0]["coverage-type"],
          memberid: coverage[0].memberid,
          network: coverage[0].network,
          period: coverage[0].period,
          "subscriber-relationship": coverage[0]["subscriber-relationship"],
          paymentDetails: cost,
        };
      }
    }

    let CheckAuthorizationResponse = await axios.post(
      // KayanURL + "api/KSA/RCM/request",
      "http://141.147.130.248:4000/api/KSA/RCM/request",
      {
        apiToken: "token",
        requestType: "2",
        payerID: visit.payerid ? visit.payerid : "",
        TPA: visit.tpa ? visit.tpa : "",
        payerName: visit.payername,
        providerName: localStorage.getItem("nphies-provider-name"),
        providerID: localStorage.getItem("nphies-id"),
        providerType:"1",
        "encounter": {
          "ID": "123456",
          "status": "finished",
          "class": {
              "code": "AMB",
              "display": "Ambulatory"
          },
          "admitSource": "WKIN",
          "serviceEventType": "ICSE",
          "period": {
              "start": "2024-08-06T10:25:00+03:00",
              "end": "2024-08-06T10:25:00+03:00"
          },
          "serviceProvider": {
              "ID": "10000300178702",
              "name": "Test"
          },
          "patientID": "2013456789"
      },
        patient: {
          ID: visit.identifier,
          firstName: visit["firstname"],
          lastName: visit["lastname"],
          phone: visit["phone"],
          gender: visit["gender"],
          birthDate: visit["birthdate"],
          identifierType: visit["identifiertype"],
               maritalStatus: "U",
          occupation: "business"
        },

        //this should be from database
        doctor: {
          firstName: doctorName[0],
          lastName: doctorLastName,
          practiceCode: doctor[0].doctor_practice_code,
          license: doctor[0].doctor_license,
        },
        codingSystem: "internal",
        related: related,
        supportingInformation: /* visit.supportinginformation */ [
          {
            "reason-for-visit": "new-visit"
          },
          {
            "vital-sign-systolic": "100"
          },
          {
            "vital-sign-diastolic": "60"
          },
          {
            "vital-sign-height": "160"
          },
          {
            "vital-sign-weight": "60"
          },
          {
            "pulse": "85"
          },
          {
            "respiratory-rate": "15"
          },
          {
            "chief-complaint": {
              "text": "LOWER ABDOMINAL PAIN, LOSS OF WEIGHT  6 KG, LOSS OF APPETITE, ALTERNATIVE DIARRHEA AND CONSTIPATION, ABDOMINAL DISCOMFORT, FLATULENCE,  BACK PAIN, HEART BURN AFTER EATING, AGGREVATED BY RECUMBENCY, RELIEVED WITH SITTING, ASSOCITED WITH ACID REGURGITATION",
              "ICD": "A00.0"
            }
          },
          {
            "temperature": "37.5"
          },
          {
            "estimated-Length-of-Stay": 2
          },
          {
            "oxygen-saturation": "5"
          },
          {
            "investigation-result": "INP"
          },
          {
            "treatment-plan": "Appendectomy"
          },
          {
            "patient-history": "No systemic disease"
          },
          {
            "physical-examination": "Stable"
          },
          {
            "history-of-present-illness": "No history"
          }
        ],
        claimType: visit.claimtype,
        diagnosis: visit.diagnosis,

        procedures: proceduresForResubmission,
        coverage: coverageInfo,
        transfer: visit.istransfer,
        newborn: visit.isnewborn,
        testing:
          /* nphiesID === "10000300178702" ? true : false, */ visit.payerid ===
            "INS-FHIR"
            ? true
            : false,
        claimSubType: "op",
        returnFullResponse: false,
      }
    );

    if (CheckAuthorizationResponse) {
      if (!id) {
        setTimeout(() => {
          this.setState({ resubmissionLoading: false });
        }, 500);
      } else {
        setTimeout(() => {
          this.setState({ re_resubmissionFlagLoading: false });
        }, 500);
      }

      let { data } = CheckAuthorizationResponse;
      console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>',data);
      
      if (data) {
        let {
          success,
          response,
          error,
          BundleID,
          PreAuthPeriod,
          items,
          Total,
          preAuthResponseIdentifier,
          adjudicationOutcome,
          requestIdentifier,
          preAuthRef,
          outcome,
        } = data;
        console.log("auth response", data);
        let updateVisit;
        if (success) {
          this.setState({ success: true /*  BundleID */, outcome });

          if (outcome === "complete") {
            //update the authorization response of the visit
            updateVisit = await this.handleAddPreAuthResponse(
              items,
              Total,
              preAuthResponseIdentifier,
              BundleID,
              adjudicationOutcome,
              outcome,
              requestIdentifier,
              preAuthRef,
              visit["id"],
              [],
              PreAuthPeriod,
              related,
              id
            );
            this.getAllAuthorizationInfo(updateVisit);
          } else if (outcome === "queued") {
            updateVisit = await this.handleAddPreAuthResponse(
              [],
              [],
              preAuthResponseIdentifier,
              BundleID,
              "",
              outcome,
              requestIdentifier,
              preAuthRef,
              visit["id"],
              [],
              {},
              related,
              id
            );
            this.getAllAuthorizationInfo(updateVisit);
          }
        } else {
          if (outcome && outcome === "error") {
            updateVisit = await this.handleAddPreAuthResponse(
              [],
              [],
              preAuthResponseIdentifier,
              BundleID,
              "",
              outcome,
              requestIdentifier,
              "",
              visit["id"],
              error,
              {},
              related,
              id
            );

            this.getAllAuthorizationInfo(updateVisit);
          } else {
            console.log(error, "error");
            this.setState({ authErrorMsg: error });
            console.log("not success");
          }
        }
      }
    }
  };
  handleAddPreAuthResponse = async (
    items,
    totals,
    authorizationresponseidentifier,
    authorizationrequestbundleid,
    adjucationoutcome,
    authorizationresponseoutcome,
    authorizationrequestidentifier,
    preAuthRef,
    visitid,
    autherror,
    preauthperiod,
    related,
    id
  ) => {
    let { proceduresSeq } = this.state;
    let currentdate = new Date();
    let createdat =
      currentdate.toISOString().slice(0, 10) +
      " " +
      currentdate.getHours() +
      ":" +
      currentdate.getMinutes() +
      ":" +
      currentdate.getSeconds();
    let data = {
      visitid: visitid,
      createdat: createdat,
      authorizationrequestbundleid: authorizationrequestbundleid,
      authorizationrequestidentifier: authorizationrequestidentifier,
      authorizationresponseidentifier: authorizationresponseidentifier,
      authorizationresponseoutcome: authorizationresponseoutcome,
      adjucationoutcome: adjucationoutcome,
      items: items,
      totals: totals,
      autherror: autherror,
      preAuthRef: preAuthRef,
      preauthperiod: preauthperiod,
      type: this.state.resubmissionFlag ? "Resubmission" : "Authorization",
      proceduresequenses:
        this.state.resubmissionFlag && proceduresSeq && proceduresSeq.length > 0
          ? proceduresSeq
          : [],
      related: related,
      authId: id,
    };
    let Response = await axios.post(
      KayanURL + "api/KSA/RCM/patient/addAuthInfo",
      {
        data,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      console.log(data);
      if (data) {
        if (data.success) {
          if (data.visit && data.visit.length > 0) {
            this.setState({
              resubmissionFlag: false,
              idForReResubmission: null,
            });
          }
          return data.visit[0];
        } else {
          console.log(
            "error in update or add the authorization response of a visit:",
            data.error
          );
          this.setState({ success: false /* , error: data.error */ });
        }
      }
    }
  };
  HandleInputSearchRequestTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let patientName,
      patientLastName = "";
    if (name === "name") {
      patientName = value.trim().split(" ");
      for (let i = 1; i < patientName.length; i++) {
        patientLastName += patientName[i] + " ";
      }
      this.setState({
        searchInfo: {
          ...this.state.searchInfo,
          firstname: patientName[0],
          lastname: patientLastName.trim(),
        },
        name: value,
      });
    } else {
      this.setState({
        searchInfo: { ...this.state.searchInfo, [name]: value },
        [name]: value,
      });
    }
  };
  handleSearchRequest = async () => {
    let { searchInfo } = this.state;
    //this.setState({ spinner: true })
    if (Object.keys(searchInfo).length === 0 || searchInfo === undefined) {
      this.setState({ errMsg: "Please select a value to search" });
    }
    for (let key in searchInfo) {
      if (searchInfo.hasOwnProperty(key) && searchInfo[key] === "") {
        this.setState({ errMsg: "Please select a value to search" });
      } else {
        this.setState({
          searchRequestSent: true,
          searchDone: false,
          errMsg: "",
        });
        let result = await axios.put(
          KayanURL + "api/KSA/RCM/patient/getAllVisistsForInsurance",
          {
            searchInfo,
            apiToken: Cookies.get("RCM_KSA_Employee_Token"),
          }
        );
        if (result) {
          let { data } = result;
          if (data) {
            this.setState({ searchRequestSent: false, searchDone: true });
            /*  this.setState({ requestsFound: true }); */
            if (data.success) {
              this.setState({
                success: true,
                allvisits: data.visits,

                /*  spinner: false  */
              });
            } else {
              this.setState({
                success: false,
                error: data.error,
                allvisits: data.visits,
              });
            }
          }
        }
      }
    }
    this.setState({
      searchInfo: {},
      identifier: "",
      name: "",
      visitstartdate: null,
      tpa: "",
      payerid: "",
      visitstartdateError: false,
    });
  };
  handlePollingRequest = async () => {
    this.setState({ pollLoading: true });
    let result = await axios.post(
      "http://141.147.130.248:4000/api/KSA/RCM/request",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),

        requestType: "5",

        providerName: localStorage.getItem("nphies-provider-name"),
        providerID: localStorage.getItem("nphies-id"),
        include: "priorauth-response",
        returnFullResponse: false,
        /*  testing: true, */
      }
    );

    if (result) {
      setTimeout(() => {
        this.setState({ pollLoading: false });
      }, 500);
      let { data } = result;

      let { success, responses, error, BundleID } = data;

      if (success) {
        if (responses && responses.length > 0 /*  || 1 */) {
          for (let i = 0; i < responses.length; i++) {
            let authResponse = responses[i];

            let {
              PreAuthPeriod,
              ResponseBuisnessIdentifier,
              outcome,
              preAuthRef,
              requestIdentifier,
              items,
              adjudicationOutcome,
              Total,
              errors,
            } = authResponse;
            if (outcome === "complete") {
              await this.handleAddPreAuthResponse(
                items,
                Total,
                ResponseBuisnessIdentifier,
                BundleID,
                adjudicationOutcome,
                outcome,
                requestIdentifier,
                preAuthRef,
                "",
                [],
                PreAuthPeriod,
                "",
                null
              );
            } else if (outcome === "error") {
              await this.handleAddPreAuthResponse(
                [],
                [],
                ResponseBuisnessIdentifier,
                BundleID,
                "",
                outcome,
                requestIdentifier,
                "",
                "",
                errors,
                {},
                "",
                null
              );
            } else if (outcome === "queued") {
              await this.handleAddPreAuthResponse(
                [],
                [],
                ResponseBuisnessIdentifier,
                BundleID,
                "",
                outcome,
                requestIdentifier,
                "",
                "",
                [],
                {},
                "",
                null
              );
            }

            // this.setState({updateVisit:true})
          }
          this.getAllVisits();
        }
      } else {
        console.log("error in polling");
        console.log(error);
        console.log("----------");
      }

      /*   if (data) {
        this.setState({ requestsFound: true });
        if (data.success) {
          this.setState({ success: true, allvisits: data.visits });
        } else {
          this.setState({
            success: false,
            error: data.error,
            searchInfo: {},
            allvisits: data.visits,
          });
        }
      } */
    }
  };
  HandleDateChange = (e) => {
    let date = moment(e.value.$d).format("YYYY-MM-DD");
    this.setState({
      searchInfo: { ...this.state.searchInfo, [e.name]: date },
      [e.name]: date,
    });
  };
  handleClosePreAuthInfo = () => {
    this.setState({
      viewPreAuthInfoModal: false,
      visitNeedApproval: null,
      editClaim: false,
      checkStatusFlag: false,
      addProcedure: false,
      addVital: false,
      addDiagnosis: false,
      vitalSignSelectArray: [],
      allDiagnosisSelect: [],
      cancelErrors: [],
      statusErrors: [],
      cancelError: ""
    });
    this.getAllVisits();
    // this.getAllAuthInfo();
  };
  handleCloseResubmission = () => {
    this.setState({ resubmissionFlag: false });
  };
  HandleVitalSignChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ vitalSelect: value });
    if (value) {
      name = value;
      this.setState({ vitalSignSelected: true, selectedName: value });
      if (value === "chief-complaint") {
        this.setState({
          chiefComplainSelected: true,
        });
      } else {
        this.setState({
          chiefComplainSelected: false,
        });
      }
      if (value == "attachment") {
        this.setState({ attachmentSelected: true });
      } else {
        this.setState({ attachmentSelected: false });
      }
    } else {
      this.setState({ vitalSignSelected: false });
    }
  };
  HandleSupportingInfoChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let { selectedName } = this.state;
    if (name === "days-supply") {
      selectedName = name;
      this.setState({ selectedName });
    }
    if (selectedName === "chief-complaint") {
      this.setState({
        vitalSignJson: { display: selectedName, valueInfo: { text: value } },
        vitalSignSelectJson: {
          display: selectedName + " " + value,
          valueInfo: value,
        },
        vitalValue: value,
      });
    } else {
      this.setState({
        vitalSignJson: { display: selectedName, valueInfo: value },
        vitalSignSelectJson: {
          display: selectedName + " " + value,
          valueInfo: value,
        },
        vitalValue: value,
      });
    }
  };

  handleConfirm = async (e) => {
    e.preventDefault();
    if (this.state.attachmentSelected && !this.state.selectedFile) {
      this.setState({
        fileMsg: "please select a file !",
      });
    } else {
      let {
        visitNeedApproval,
        supportingInfoarray,
        vitalSignJson,
        vitalSignSelectJson,
        vitalSignSelectArray,
      } = this.state;
      console.log(vitalSignJson, "vitalJsoon");
      this.setState({ vitalSelect: "", vitalValue: "" });
      if (this.state.selectedName === "attachment") {
        const lastModifiedDateStr = vitalSignJson.valueInfo.lastModifiedDate;

        const lastModifiedDate = new Date(lastModifiedDateStr);
        const year = lastModifiedDate.getFullYear();
        const month = String(lastModifiedDate.getMonth() + 1).padStart(2, "0");
        const day = String(lastModifiedDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        visitNeedApproval["supportinginformation"].push({
          [vitalSignJson.display]: {
            contentType: vitalSignJson.valueInfo.type,
            title: vitalSignJson.valueInfo.name,
            data: vitalSignJson.data,
            // creation: (vitalSignJson.valueInfo.lastModifiedDate.toString()).split('(')[0].trim()
            creation: formattedDate,
          },
        });
      } else {
        if (
          visitNeedApproval.supportinginformation &&
          visitNeedApproval.supportinginformation.length > 0
        ) {
          visitNeedApproval["supportinginformation"].push({
            [vitalSignJson.display]: vitalSignJson.valueInfo,
          });
        } else {
          visitNeedApproval["supportinginformation"].push({
            [vitalSignJson.display]: vitalSignJson.valueInfo,
          });
        }
      }

      // vitalSignsArray.push(vitalSignJson);

      if (this.state.selectedName !== "days-supply")
        vitalSignSelectArray.push(vitalSignSelectJson);

      this.setState((prevState) => ({
        selectedFile: "",
        addVital: false,
        vitalSignSelectArray,
        key: prevState.key + 1,
      }));
    }
  };
  handleDeleteVital = (index) => {
    let { vitalSignSelectArray, visitNeedApproval } = this.state;
    vitalSignSelectArray.splice(index, 1);
    if (
      visitNeedApproval["allprocedures"] &&
      visitNeedApproval["allprocedures"].length > 0
    ) {
      let procedures = visitNeedApproval["allprocedures"];
      for (let i = 0; i < procedures.length; i++) {
        let infoSeq;
        if (
          procedures[i].informationSequence &&
          procedures[i].informationSequence.length > 0
        ) {
          infoSeq = procedures[i].informationSequence;
          let target = index + 1;
          if (infoSeq.includes(index + 1)) {
            infoSeq.splice(infoSeq.indexOf(target), 1);
            for (let i = 0; i < infoSeq.length; i++) {
              if (infoSeq[i] > target) {
                infoSeq[i] = infoSeq[i] - 1;
              } else {
                infoSeq[i] = infoSeq[i];
              }
            }
          } else {
            console.log("here");
            for (let i = 0; i < infoSeq.length; i++) {
              if (infoSeq[i] > target) {
                infoSeq[i] = infoSeq[i] - 1;
              } else {
                infoSeq[i] = infoSeq[i];
              }
            }
          }
          procedures[i].informationSequence = infoSeq;
        }
      }
      visitNeedApproval["allprocedures"] = procedures;
    }
    visitNeedApproval.supportinginformation.splice(index, 1);
    if (visitNeedApproval.supportinginformation.length == 0)
      this.setState({ addVital: true });
    this.setState({ vitalSignSelectArray, visitNeedApproval });
  };
  HandleDiagnosisChange = (e) => {
    if (this.state.claimType === "institutional") {
      this.setState({
        diagnosisJson: {
          ...this.state.diagnosisJson,
          [e.target.name]: e.target.value,
          onAdmission: false,
        },
        diagnosisType: e.target.value,
      });
    } else {
      this.setState({
        diagnosisJson: {
          ...this.state.diagnosisJson,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  getAllDiagnosis = async () => {
    let diagnosisOptions = await axios.put(
      "https://test.kayan-healthcare.com/api/ksa/getAllDiagnosis/",
      {}
    );
    if (diagnosisOptions) {
      let { data } = diagnosisOptions;
      if (data) {
        this.setState({ success: true, allDiagnosisOptions: data });
      } else {
        this.setState({ success: false, loading: true });
      }
    }
  };
  handleDiagnosisSelect = (value) => {
    let split = value.split("-");
    let code = split[0];
    let description = split[1];
    this.setState({
      diagnosisJson: {
        ...this.state.diagnosisJson,
        code: code,
        description: description,
      },
      autoCompleteValue: false,
    });
  };
  handleSubmitAddNewDiagnosis = async (e) => {
    e.preventDefault();
    let { diagnosisJson, allDiagnosisSelect, visitNeedApproval } = this.state;
    this.setState({ autoCompleteValue: true });
    let flag = false
    if (visitNeedApproval.diagnosis && visitNeedApproval.diagnosis.length > 0 && diagnosisJson.type === "principal") {
      flag = visitNeedApproval.diagnosis.some(item => item.type === "principal");

    } if (flag) {
      this.setState({ diagCodeErrorMsg: "The Principal Diagnosis Type is exist!" })
    } else {
      this.setState({ diagCodeErrorMsg: "" })
      if (visitNeedApproval.diagnosis && visitNeedApproval.diagnosis.length > 0) {
        visitNeedApproval["diagnosis"].push(diagnosisJson);
      } else {
        visitNeedApproval["diagnosis"].push(diagnosisJson);
      }
      this.setState({
        addDiagnosis: false,
      });
      if (allDiagnosisSelect.length == 0) {
        let allDiagnosisArray = visitNeedApproval.diagnosis;
        for (let i = 0; i < allDiagnosisArray.length; i++) {
          allDiagnosisSelect.push({
            view: allDiagnosisArray[i].type + " " + allDiagnosisArray[i].code,
          });
        }
      } else {
        allDiagnosisSelect.push({
          view: diagnosisJson.type + " " + diagnosisJson.code,
        });
      }
      this.setState((prevState) => ({
        allDiagnosisSelect,
        diagKey: prevState.diagKey + 1,
      }));
    }

    // console.log(allDiagnosisSelect, "diagSelect");
  };
  handleDeleteDiagnosis = (index) => {
    let { allDiagnosisSelect, visitNeedApproval } = this.state;
    allDiagnosisSelect.splice(index, 1);
    if (
      visitNeedApproval["allprocedures"] &&
      visitNeedApproval["allprocedures"].length > 0
    ) {
      let procedures = visitNeedApproval["allprocedures"];
      for (let i = 0; i < procedures.length; i++) {
        // console.log(procedures[i], "hiiii")
        let diagSeq;
        if (
          procedures[i].diagnosisSequence &&
          procedures[i].diagnosisSequence.length > 0
        ) {
          diagSeq = procedures[i].diagnosisSequence;
          let target = index + 1;
          if (diagSeq.includes(index + 1)) {
            diagSeq.splice(diagSeq.indexOf(target), 1);
            for (let i = 0; i < diagSeq.length; i++) {
              if (diagSeq[i] > target) {
                diagSeq[i] = diagSeq[i] - 1;
              } else {
                diagSeq[i] = diagSeq[i];
              }
            }
          } else {
            console.log("here");
            for (let i = 0; i < diagSeq.length; i++) {
              if (diagSeq[i] > target) {
                diagSeq[i] = diagSeq[i] - 1;
              } else {
                diagSeq[i] = diagSeq[i];
              }
            }
          }
          procedures[i].diagnosisSequence = diagSeq;
        }
      }
      visitNeedApproval["allprocedures"] = procedures;
    }
    // console.log(visitNeedApproval["allprocedures"], 'ccccccc')
    visitNeedApproval["diagnosis"].splice(index, 1);
    if (visitNeedApproval.diagnosis.length == 0)
      this.setState({ addDiagnosis: true });
    this.setState((prevState) => ({
      allDiagnosisSelect,
      diagKey: prevState.diagKey + 1,
    }));
    // this.setState({ visitNeedApproval, allDiagnosisSelect });
  };
  handleCodeChange = (event, value) => {
    let { priceList, medicationList, procedure } = this.state;

    let genericMedicationDeduction;
    let brandedMedicationDeduction;
    let dentalDeduction;

    let { visitNeedApproval } = this.state;

    if (visitNeedApproval) {
      let { selectedinsurance } = visitNeedApproval;

      if (selectedinsurance && selectedinsurance.length > 0) {
        selectedinsurance = selectedinsurance[0];
        let { items } = selectedinsurance;

        if (items && items.length > 0) {
          let filterdGenericMedicationDeduction = items.filter(
            (item) =>
              item.benefitType == "copay-percent" && item.category == "66"
          );

          if (
            filterdGenericMedicationDeduction &&
            filterdGenericMedicationDeduction.length > 0
          ) {
            filterdGenericMedicationDeduction =
              filterdGenericMedicationDeduction[0];

            let { allowedMoney } = filterdGenericMedicationDeduction;
            genericMedicationDeduction = allowedMoney;

            this.setState({
              genericMedicationDeduction: genericMedicationDeduction,
            });
          } else {
            genericMedicationDeduction = 20;
            this.setState({ genericMedicationDeduction });
          }

          let filterdBrandedMedicationDeduction = items.filter(
            (item) =>
              item.benefitType == "copay-percent" && item.category == "57"
          );

          if (
            filterdBrandedMedicationDeduction &&
            filterdBrandedMedicationDeduction.length > 0
          ) {
            filterdBrandedMedicationDeduction =
              filterdBrandedMedicationDeduction[0];

            let { allowedMoney } = filterdBrandedMedicationDeduction;
            brandedMedicationDeduction = allowedMoney;
            this.setState({ brandedMedicationDeduction });
          } else {
            brandedMedicationDeduction = 50;
            this.setState({ brandedMedicationDeduction });
          }

          let filterdDentalDeduction = items.filter(
            (item) =>
              item.benefitType == "copay-percent" && item.category == "26"
          );

          if (filterdDentalDeduction && filterdDentalDeduction.length > 0) {
            filterdDentalDeduction = filterdDentalDeduction[0];
            let { allowedMoney } = filterdDentalDeduction;
            dentalDeduction = allowedMoney;
            this.setState({ dentalDeduction });
          } else {
            dentalDeduction = this.state.generalCopayment;
            this.setState({ dentalDeduction });
          }
        }
      }
    }

    console.log("inside handle code change", this.state);

    console.log("dental deduction", dentalDeduction);
    if (value) {
      this.setState({ filteredPriceList: [] });
      if (procedure.type === "medication") {
        let arr = value.split("_");

        let filteredPriceList = medicationList.filter(
          (e) => e.gtincode === arr[0] && e.description === arr[1]
        );

        let code;

        if (filteredPriceList && filteredPriceList.length > 0) {
          code = filteredPriceList[0];

          let { price, category } = code;

          procedure["price"] = parseFloat(price);
          procedure["discount"] = 0;
          procedure["tax"] = 0;
          procedure["code"] = arr[0];
          procedure["category"] = category;

          procedure["description"] = arr[1];

          //check medication info if the medication is generic or branded
          if (category == "generic") {
            //get the generic copay percent
            //category 66 from table of benefit
            procedure["deduction"] = this.state.genericMedicationDeduction
              ? this.state.genericMedicationDeduction
              : genericMedicationDeduction;
          } else if (category == "branded") {
            //get the branded copay percent

            procedure["deduction"] = this.state.brandedMedicationDeduction
              ? this.state.brandedMedicationDeduction
              : brandedMedicationDeduction;
          }

          this.setState({ procedure });
          this.setState({
            autoValue: value,
            filteredPriceList,
          });
        }
        this.HandleprocedureCalculation();
      } else {
        let splitedInfo = value.split("/ SBS:");

        let internalInfo = splitedInfo[0];
        let SBSinfo = splitedInfo[1];

        let internalCode = internalInfo.split("_")[0];
        let internalDescription = internalInfo.split("_")[1];
        let SBScode = SBSinfo.split("_")[0].trim();

        let SBSDescription = SBSinfo.split("_")[1];

        let filteredPriceList = priceList.filter(
          (e) =>
            e.internalcode === internalCode &&
            e.internaldescription === internalDescription &&
            e.sbscode === SBScode
        );

        let code;

        if (filteredPriceList && filteredPriceList.length > 0) {
          code = filteredPriceList[0];

          let { price, discount } = code;

          procedure["price"] = parseFloat(price);
          procedure["discount"] = parseFloat(discount);
          procedure["code"] = internalCode;
          procedure["description"] = internalDescription;
          if (procedure["type"] == "dental") {
            procedure["deduction"] = this.state.dentalDeduction
              ? this.state.dentalDeduction
              : dentalDeduction;
          } else {
            procedure["deduction"] = this.state.generalCopayment;
          }
          this.setState({ procedure });
          this.setState({
            autoValue: value,
            filteredPriceList,
          });
        }

        this.HandleprocedureCalculation();
      }
    }
  };

  HandleprocedureCalculation = (e) => {
    console.log("procedure to calculate");
    console.log(this.state.procedure);

    let { procedure } = this.state;

    let { deduction, patientshare, quantity, type, price, discount } =
      procedure;
    let priceAfterDiscount = 0,
      net = 0,
      tax = 0;

    let factor = 1;
    if (discount && discount != 0) {
      factor = 1 - discount / 100;
    }

    if (price) {
      priceAfterDiscount = parseFloat(quantity * price * factor);
      if (type != "medication") {
        tax = parseFloat(priceAfterDiscount * 0.15).toFixed(2);
      }

      patientshare = parseFloat(priceAfterDiscount * (deduction / 100)).toFixed(
        2
      );

      if (type != "medication") {
        net = parseFloat(
          priceAfterDiscount + priceAfterDiscount * 0.15
        ).toFixed(2);
      } else {
        let t = 0;
        net = parseFloat(priceAfterDiscount + t).toFixed(2);
      }

      procedure["factor"] = factor;
      procedure["priceAfterDiscount"] = priceAfterDiscount;
      procedure["tax"] = tax;
      procedure["patientshare"] = patientshare; /* ?patientshare:0 */
      procedure["net"] = net;

      // console.log("****************************", procedure);

      this.setState({ procedure });
    }
  };

  handleOpenProcedure = (e) => {
    console.log("open");
    console.log(this.state);

    let copaypct;

    let { visitNeedApproval } = this.state;
    if (visitNeedApproval) {
      let { selectedinsurance } = visitNeedApproval;

      if (selectedinsurance && selectedinsurance.length > 0) {
        selectedinsurance = selectedinsurance[0];
        let { coverage } = selectedinsurance;

        if (coverage && coverage.length > 0) {
          coverage = coverage[0];
          let { paymentDetails } = coverage;
          if (paymentDetails && paymentDetails.length > 0) {
            let copaypctfiltered = paymentDetails.filter(
              (detail) => detail.copaypct != undefined
            );

            if (copaypctfiltered && copaypctfiltered.length > 0) {
              copaypct = copaypctfiltered[0].copaypct;
              if (copaypct) {
                copaypct = copaypct.split(" ")[0];
              }
            }
          }
        }
      }
    }

    console.log("copay percentage", copaypct);
    let procedure = {};
    //copaypct by default from the coverage , and will be updated later from the table of benefit based on the procedure type
    procedure = {
      quantity: 1,
      deduction: 0,
      patientshare: 0,
    };
    this.setState({ generalCopayment: copaypct });
    // console.log(procedure);

    this.setState({
      addProcedure: "true",
      procedure,
    });
  };
  HandleProcedureChange = (e) => {
    let value = e.target.value;

    let { procedure } = this.state;

    if (e.target.name == "type") {
      procedure["type"] = value;
      this.setState({ procedure });
      this.setState({
        //serviceValue: e.target.value,
        attachmentFlag: false,
        showToothNumber: false,
        pharmacistSelection: false,
        autoValue: "",
      });
      if (e.target.value == "dental") {
        this.setState({ showToothNumber: true });
        this.getPriceList();
      } else if (e.target.value == "medication") {
        this.setState({ pharmacistSelection: true });
        this.getMedicationList();
      } else {
        this.getPriceList();
      }
    }
    if (e.target.name == "quantity") {
      procedure["quantity"] = value;
      this.setState({ procedure });
    }
    if (e.target.name == "deduction") {
      console.log("deduction", e.target.value);
      procedure["deduction"] = e.target.value;
    }
    if (e.target.name == "price") {
      procedure["price"] = value;
      this.setState({ procedure });
    }
    if (e.target.name == "discount") {
      procedure["discount"] = value;
      this.setState({ procedure });
    }

    if (e.target.name === "pharmacistSelectionReason") {
      procedure["pharmacistSelectionReason"] = value;
      this.setState({ procedure });
    }

    if (e.target.name == "toothNumber") {
      let toothNumberInfo = value.split("-");

      procedure["toothNumber"] = toothNumberInfo[0];
      procedure["toothDescription"] = toothNumberInfo[1];
      this.setState({ procedure });
    }

    this.HandleprocedureCalculation();
  };
  handleDeleteProcedure = (index) => {
    let { visitNeedApproval } = this.state;
    visitNeedApproval["allprocedures"].splice(index, 1);
    if (visitNeedApproval["allprocedures"].length == 0)
      this.setState({ addProcedure: true });
    this.setState({ visitNeedApproval });
  };
  handleSubmitAddNewProcedure = async (e) => {
    e.preventDefault();
    let {
      procedure,
      filteredPriceList,
      visitNeedApproval,
      supportingInfoarray,
    } = this.state;
    if (this.state.procedureQuantity == 1) {
      procedure["quantity"] = this.state.procedureQuantity;
    }
    if (this.state.procedureShare == 0) {
      procedure["patientshare_total"] = this.state.procedureShare;
    }
    procedure["tax_calculated"] = parseInt(
      (
        parseInt(filteredPriceList[0].price) *
        this.state.procedureQuantity *
        (1 - parseInt(filteredPriceList[0].discount) / 100) *
        0.15
      ).toFixed(2)
    );
    if (this.state.selectedName === "days-supply") {
      console.log("hereeeeeeeee");
      this.handleConfirm(e);
      let seq;
      if (visitNeedApproval["supportinginformation"].length == 1) {
        seq = 1;
      } else {
        seq = visitNeedApproval["supportinginformation"].length;
      }
      if (
        procedure["informationSequence"] &&
        procedure["informationSequence"].length > 0
      ) {
        procedure["informationSequence"].push(seq);
      } else {
        procedure["informationSequence"] = [seq];
      }

      // console.log(procedure, "hhhhh");
    }

    // this.setState({
    //   incorrectProcedureErrorMessage: "",
    //   autoValue: "",
    //   procedureQuantity: 1,
    //   procedureShare: 0,
    //   procedureDescription: "",
    //   procedureStatus: "",
    //   serviceValue: "",
    //   toothNumberValue: "",
    //   showToothNumber: false,
    //   pharmacistSelectionReasonValue: "",
    //   pharmacistSelection: false,
    //   attachmentFlag: false
    // });
    let currentdate = new Date();
    let date = moment(currentdate).format("YYYY-MM-DD");
    procedure["date"] = date;
    procedure["package"] = false;
    //procedure["date"] = "2024-01-24";

    procedure["package"] = false;
    visitNeedApproval["allprocedures"].push(procedure);
    this.setState({
      incorrectProcedureErrorMessage: "",
      autoValue: "",
      procedureQuantity: 1,
      procedureShare: 0,
      procedureDescription: "",
      procedureStatus: "",
      serviceValue: "",
      toothNumberValue: "",
      showToothNumber: false,
      pharmacistSelectionReasonValue: "",
      pharmacistSelection: false,
      attachmentFlag: false,
      addProceduretotable: true,
      procedure: {},
      selectedName: "",
      addProcedure: false,
    });
  };
  getPriceList = async () => {
    let autoOptions = [];
    let priceList = await axios.put(
      KayanURL + "api/KSA/RCM/priceList/getPriceList",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        payerid: this.state.visitNeedApproval.payerid,
      }
    );
    if (priceList) {
      let { data } = priceList;
      if (data) {
        if (data.success) {
          let { pricelist } = data;
          /*  pricelist.forEach((e) => {
            autoOptions.push(`${e.internalcode}_${e.internaldescription}`);
          }); */

          pricelist.forEach((e) => {
            autoOptions.push(
              `${e.internalcode}_${e.internaldescription}/ SBS:${e.sbscode}_${e.sbsdescription}`
            );
          });
          console.log(autoOptions);

          this.setState({ priceList: pricelist, autoOptions: autoOptions });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  getMedicationList = async () => {
    // let {autoOptions}=this.state;
    let autoOptions = [];

    let response = await axios.put(
      KayanURL + "api/KSA/RCM/priceList/getAllMedication",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        if (data.success) {
          let { medicationList } = data;
          medicationList.forEach((e) => {
            autoOptions.push(`${e.gtincode}_${e.description}`);
          });
          console.log(autoOptions);
          this.setState({
            medicationList: medicationList,
            autoOptions: autoOptions,
          });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  onSelectDiagnosis = (selectedList) => {
    let { allDiagnosisSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(allDiagnosisSelect.indexOf(item) + 1);
    });

    this.setState({
      procedure: {
        ...this.state.procedure,
        diagnosisSequence: Values,
      },
    });
  };
  onRemoveDiagnosis = (selectedList, removedItem) => {
    let { allDiagnosisSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        allDiagnosisSelect.indexOf(item) + 1 !=
        allDiagnosisSelect.indexOf(removedItem) + 1
      ) {
        Values.push(allDiagnosisSelect.indexOf(item) + 1);
      }
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        diagnosisSequence: Values,
      },
    });
  };
  SelectDiagnosisForProcedure = (selectedList, index) => {
    let { allDiagnosisSelect, visitNeedApproval } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(allDiagnosisSelect.indexOf(item) + 1);
    });
    visitNeedApproval["allprocedures"][index].diagnosisSequence = Values;
    this.setState({
      visitNeedApproval,
    });
  };
  RemoveDiagnosisForProcedure = (selectedList, removedItem, index) => {
    let { allDiagnosisSelect, visitNeedApproval } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        allDiagnosisSelect.indexOf(item) + 1 !=
        allDiagnosisSelect.indexOf(removedItem) + 1
      ) {
        Values.push(allDiagnosisSelect.indexOf(item) + 1);
      }
    });
    visitNeedApproval["allprocedures"][index].diagnosisSequence = Values;
    console.log(visitNeedApproval["diagnosis"], "ffff");
    this.setState({
      visitNeedApproval,
    });
  };
  onSelectCategory = (selectedList) => {
    let { vitalSignSelectArray } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(vitalSignSelectArray.indexOf(item) + 1);
    });

    this.setState({
      procedure: {
        ...this.state.procedure,
        informationSequence: Values,
      },
    });
  };
  SelectCategoryForProcedure = (selectedList, index) => {
    let { vitalSignSelectArray, visitNeedApproval } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(vitalSignSelectArray.indexOf(item) + 1);
    });
    visitNeedApproval["allprocedures"][index].informationSequence = Values;
    this.setState({
      visitNeedApproval,
    });
    // }
  };
  RemoveCategoryForProcedure = (selectedList, removedItem, index) => {
    let { vitalSignSelectArray, visitNeedApproval } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        vitalSignSelectArray.indexOf(item) + 1 !=
        vitalSignSelectArray.indexOf(removedItem) + 1
      ) {
        Values.push(vitalSignSelectArray.indexOf(item) + 1);
      }
    });
    visitNeedApproval["allprocedures"][index].informationSequence = Values;
    this.setState({
      visitNeedApproval,
    });
  };
  onRemoveCategory = (selectedList, removedItem) => {
    let { vitalSignSelectArray } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        vitalSignSelectArray.indexOf(item) + 1 !=
        vitalSignSelectArray.indexOf(removedItem) + 1
      ) {
        Values.push(vitalSignSelectArray.indexOf(item) + 1);
      }
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        informationSequence: Values,
      },
    });
  };
  handleSave = async (e) => {
    e.preventDefault();
    let { visitNeedApproval, calimDefaultValue, editClaim } = this.state;
    if (editClaim) {
      this.setState({
        saveLoading: true,
        addVital: false,
        addProcedure: false,
        addDiagnosis: false,
      });
      let Response = await axios.post(
        KayanURL + "api/KSA/RCM/patient/addForNeed",
        {
          id: visitNeedApproval.id,
          claimType: calimDefaultValue,
          diagnosis: JSON.stringify(visitNeedApproval["diagnosis"]),
          allProcedures: JSON.stringify(visitNeedApproval["allprocedures"]),
          proceduresNeedAproval: JSON.stringify(
            visitNeedApproval["allprocedures"]
          ),
          supportingInformation: JSON.stringify(
            visitNeedApproval["supportinginformation"]
          ),
          visitStatus: "4",
          startDateVisit: visitNeedApproval.visitstartdate,
          isNeedSubmission: true,
          isNeedApproval: true,
          claimSubmissionStatus: visitNeedApproval.claimsubmissionstatus,
          authorizationStatus: visitNeedApproval.authorizationstatus,
          endVisitDate: visitNeedApproval.visitenddate,
          apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        }
      );
      if (Response) {
        setTimeout(() => {
          this.setState({ saveLoading: false });
        }, 1000);
        let { data } = Response;
        if (data) {
          if (data.success) {
            this.setState({
              success: true,
              editClaim: false,
              updateVisit: true,
            });
            this.getAllVisits();
          } else {
            this.setState({ success: false, error: data.error });
          }
        }
      }
    }
  };
  handleCansulation = async (e, element) => {
    e.preventDefault();
    // console.log(element,'cancelElem')
    let { nphiesID } = this.state;
    this.setState({
      cancelLoading: true,
      cancelErrors: [],
      cancelError: ""
    });
    let CancelResponse = await axios.post(
      // KayanURL
      "http://141.147.130.248:4000/" + "api/KSA/RCM/request",
      {
        apiToken: "token",
        requestType: "6",
        payerID: element.payerid,
        TPA: element.tpa ? element.tpa : "",
        providerID: nphiesID,
        providerName: localStorage.getItem("nphies-provider-name"),

        payerName: element.payername,
        requestIdentifier: element.authorizationRequestIdentifier,
        code: "cancel",
        testing: nphiesID === "10000300178702" ? true : false,
      }
    );

    // console.log("cancel Response", CancelResponse);

    if (CancelResponse) {
      setTimeout(() => {
        this.setState({ cancelLoading: false });
      }, 500);
      let { data } = CancelResponse;
      if (data) {
        let { success, error, response } = data;
        if (success) {
          let cancelStatus;
          /*  console.log(success);
 
           console.log(response); */

          let res = response/*  JSON.parse(response) */;

          let { entry } = res;
          if (entry && entry.length > 0) {
            let { reference } = entry[0]["resource"]["focus"][0];
            let taskResource = entry.filter((element) => {
              return element["fullUrl"] == reference;
            });

            if (taskResource && taskResource.length > 0) {
              let errors = [];
              let { output, status, code } = taskResource[0]["resource"];

              if (output && output.length > 0) {
                for (let i = 0; i < output.length; i++) {
                  if (status == "failed") {


                    let outputItem = output[i];

                    let { type, valueString } = outputItem;
                    if (type) {
                      let { coding } = type;
                      if (coding && coding.length > 0) {
                        coding = coding[0];

                        let { code } = coding;
                        if (code == "error") {
                          errors.push({
                            codeError: code,
                            errorMsg: valueString,
                            details: valueString,
                          });
                          this.setState({ cancelErrors: errors });
                        }
                      }
                    }
                  }
                }
              } else {
                if (code.coding && code.coding.length > 0) {
                  cancelStatus = code.coding[0].code;
                }
              }
            }
          }
          if (cancelStatus === "cancel") {


            let updateResponse = await axios.put(
              KayanURL + "api/KSA/RCM/patient/updateVisitStatus",
              {
                apiToken: Cookies.get("RCM_KSA_Employee_Token"),
                visitid: element.id,
                authorizationresponseoutcome: "cancellation",
              }
            );

            if (updateResponse) {
              let { data } = updateResponse;
              if (data) {
                console.log(data);
                let { success, error } = data;
                if (success) {
                  this.setState({ checkStatusFlag: false });
                  this.getAllAuthorizationInfo(data.visit[0]);
                }
              }
            }
          }
        } else {
          this.setState({ cancelError: error })
        }
      }
    }
  };
  handleCheck = async (e, element) => {
    console.log(element, "check status");
    e.preventDefault();
    let { nphiesID } = this.state;
    this.setState({ statusLoading: true, statusErrors: [], cancelErrors: [], cancelError: "" });
    let errors = [];
    let checkStatusRequest = await axios.post(
      "http://141.147.130.248:4000/api/KSA/RCM/request",
      // KayanURL + "api/KSA/RCM/request",
      {
        apiToken: "token",
        requestType: 8,
        payerID: element.payerid,
        TPA: element.tpa ? element.tpa : "",
        providerID: nphiesID,
        providerName: localStorage.getItem("nphies-provider-name"),
        payerName: element.payername,
        requestIdentifier: element.authorizationRequestIdentifier,
        testing: nphiesID === "10000300178702" ? true : false,
      }
    );

    if (checkStatusRequest) {
      setTimeout(() => {
        this.setState({ statusLoading: false });
      }, 1000);

      let { data } = checkStatusRequest;

      if (data) {
        console.log(data);
        setTimeout(() => {
          this.setState({ checkStatusFlag: false });
        }, 2000);
        let { success, error, response } = data;
        if (success) {
          this.setState({ checkStatusFlag: true });

          let res =response /* JSON.parse(response); */

          let { entry } = res;
          if (entry && entry.length > 0) {
            let { reference } = entry[0]["resource"]["focus"][0];
            let taskResource = entry.filter((element) => {
              return element["fullUrl"] == reference;
            });

            if (taskResource && taskResource.length > 0) {
              let { output, status } = taskResource[0]["resource"];
              console.log(taskResource, "tasks");
              if (output && output.length > 0) {
                for (let i = 0; i < output.length; i++) {
                  console.log(output[i], "output");
                  if (status == "failed") {
                    let { code, display } =
                      output[i]["valueCodeableConcept"]["coding"][0];
                    let { valueString } =
                      output[i]["valueCodeableConcept"]["coding"][0][
                      "extension"
                      ][0];
                    errors.push({
                      codeError: code,
                      errorMsg: display,
                      details: valueString,
                    });
                    this.setState({ valueCode: "", statusErrors: errors });
                  } else {
                    let { valueCode } = output[i];
                    this.setState({ valueCode });
                  }
                }
              }
            }
          }
          this.setState({ res, success, errors });
        } else {
          this.setState({ error });
          console.log(error);
        }
      }
    }
  };

  //communication
  handleCloseCommunicationModal = () => {
    this.setState({
      communicationModalOpen: false,
      communicationError: [],
      acknowledgmentStatus: "",
      communicationCategory: "",
      content: "",
      basedOnValue: "",
      communicationData: "",
      communicationFileName: "",
    });
  };
  handleCloseErrorModal = () => {
    this.setState({
      communicationTransactionErrors: [],
      showError: false,
    });
  };
  handleCloseCommunicationHistoryModal = () => {
    this.setState({ communicationHistoryModalOpen: false });
  };
  HandleCommunicationInputChange = async (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "communicationAttachment") {
      let res = await this.readContent(e.target.files[0]);
      this.setState({
        communicationData: res,
        communicationFileName: e.target.files[0].name.split(".")[0],
      });
    } else {
      this.setState({ [name]: value });
    }
  };
  handleSend = async (e) => {
    e.preventDefault();
    let { visitNeedApproval, nphiesID } = this.state;
    // console.log(visitNeedApproval, 'from communication')
    this.setState({
      sendLoading: true,
      communicationError: [],
      acknowledgmentStatus: "",
    });
    let errors = [];
    let basedOn;
    let sendRequest = await axios.post(
      "http://141.147.130.248:4000/api/KSA/RCM/request",
      // KayanURL + "api/KSA/RCM/request",
      {
        apiToken: "token",
        requestType: 9,
        payerID: visitNeedApproval.payerid,
        TPA: visitNeedApproval.tpa ? visitNeedApproval.tpa : "",
        providerID: nphiesID,
        providerName: localStorage.getItem("nphies-provider-name"),
        providerType:"1",
        payerName: visitNeedApproval.payername,
        claimRequestIdentifier:
          visitNeedApproval.authorizationRequestIdentifier,
        content: this.state.content,
        communicationCategory: this.state.communicationCategory,
        "priority":"routine",
        "medium":"ELECTRONIC",
        "reasonCode":"missing-info",
        patient: {
          ID: visitNeedApproval.identifier,
          firstName: visitNeedApproval["firstname"],
          lastName: visitNeedApproval["lastname"],
          phone: visitNeedApproval["phone"],
          gender: visitNeedApproval["gender"],
          birthDate: visitNeedApproval["birthdate"],
          identifierType: visitNeedApproval["identifiertype"],
            maritalStatus: "U",
          occupation: "business"
        },
        attachmentEncodedData: this.state.communicationData,
        title: this.state.communicationFileName,
        testing: true,
      }
    );

    if (sendRequest) {
      let { data } = sendRequest;
      if (data) {
        console.log(data, "from comunication");

        let { success, error, BundleID, acknowledgmentStatus } = data;
        if (BundleID) {
          this.setState({ BundleID });
        }
        if (this.state.basedOnValue) {
          basedOn = this.state.basedOnValue;
        } else {
          basedOn = "";
        }
        if (success) {
          setTimeout(() => {
            this.setState({ sendLoading: false });
          }, 2000);
          if (
            acknowledgmentStatus === "fatal-error" &&
            error &&
            error.length > 0
          ) {
            this.setState({ communicationError: error, acknowledgmentStatus });
            this.handleAddCommunicationTransactionInfo(
              this.state.communicationData,
              this.state.content,
              visitNeedApproval.authorizationRequestIdentifier,
              this.state.communicationCategory,
              error,
              basedOn
            );
          } else {
            this.setState({ acknowledgmentStatus });
            this.handleAddCommunicationTransactionInfo(
              this.state.communicationData,
              this.state.content,
              visitNeedApproval.authorizationRequestIdentifier,
              this.state.communicationCategory,
              [],
              basedOn
            );
          }
        } else {
          this.setState({ error });
          console.log(error);
        }
      }
    }
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }
    this.setState({
      content: "",
      communicationCategory: "",
    });
  };
  handleAddCommunicationTransactionInfo = async (
    communicationData,
    content,
    authorizationRequestIdentifier,
    communicationCategory,
    error,
    basedOn
  ) => {
    let Response = await axios.post(
      KayanURL + "api/KSA/RCM/patient/addCommunicationTransaction",
      {
        data: {
          attachment: communicationData,
          content: content,
          communicationType: basedOn ? "solicited" : "unsolicited",
          requestType: "Authorization",
          basedOn: basedOn ? basedOn : "",
          communicationError: error,
          requestIdentifier: authorizationRequestIdentifier,
          communicationCategory: communicationCategory,
          acknowledgmentStatus: error && error.length > 0 ? "not sent" : "sent",
        },
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      console.log(data);
      if (data) {
        if (data.success) {
          this.getAllCommunicationTransactionInfoByReqIdentefier();
          if (basedOn && error.length === 0) {
            this.handleUpdateCommunicationRequeststatus();
          }
        } else {
          this.setState({ success: false });
        }
      }
    }
  };
  handleUpdateCommunicationRequeststatus = async () => {
    let Response = await axios.put(
      KayanURL + "api/KSA/RCM/patient/updateCommunicationRequest",
      {
        communicationAbout: this.state.communicationAboutValue,
        acknowledgmentStatus: "replyed",
        ID: this.state.idValue,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      console.log(data);
      if (data) {
        if (data.success) {
          this.getAllCommunicationRequestInfoByReqIdentefier();
        } else {
          console.log(
            "error in update or add the authorization response of a visit:",
            data.error
          );
          this.setState({ success: false /* , error: data.error */ });
        }
      }
    }
  };
  getAllCommunicationTransactionInfoByReqIdentefier = async () => {
    this.setState({ communicationTransactionLoading: true });
    let response = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getCommunicationTransaction",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        requestIdentifier:
          this.state.visitNeedApproval.authorizationRequestIdentifier,
        requestType: "Authorization",
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        this.setState({ communicationTransactionLoading: false });
        if (data.success) {
          this.setState({
            success: true,
            communicationTransactionSuccess: true,
            transactionsData: data.transactionsData,
          });
        } else {
          this.setState({
            success: false,
            communicationTransactionSuccess: false,
            error: data.error,
          });
        }
      }
    }
  };
  getAllCommunicationRequestInfoByReqIdentefier = async () => {
    // e.preventDefault();
    this.setState({ communicationRequestLoading: true });
    console.log(this.state.visitNeedApproval, "from get comm");
    let response = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getCommunicationRequest",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        communicationAbout:
          this.state.visitNeedApproval.authorizationRequestIdentifier,
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        this.setState({ communicationRequestLoading: false });
        if (data.success) {
          this.setState({
            success: true,
            communicationReqSuccess: true,
            requestData: data.requestData,
          });
        } else {
          this.setState({
            success: false,
            communicationReqSuccess: false,
            error: data.error,
          });
        }
      }
    }
  };
  handlePollingCommunicationRequest = async () => {
    this.setState({ pollCommLoading: true });
    let result = await axios.post(
      "http://141.147.130.248:4000/api/KSA/RCM/request",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),

        requestType: "5",
        providerName: localStorage.getItem("nphies-provider-name"),
        providerID: localStorage.getItem("nphies-id"),
        include: "communication-request",
        returnFullResponse: false,
        testing: true,
      }
    );
    // result = {
    //   data: {
    //     "success": true,
    //     "BundleID": "b22b775e-0e24-49f5-9c28-3c4ac62cf96f",
    //     "communicationRequests": [
    //       {
    //         "communicationRequestIdentifier": "http://sni.com.sa/communicationrequest/CommReq_306278",
    //         "communicationCategory": "instruction",
    //         "communicationContent": [
    //           {
    //             "contentString": "Please provide an updated lab report including HbAIC, LFT and Lipid profiles."
    //           }
    //         ],
    //         "communicationAbout": "http://141.147.130.248/authorization/req_32671"
    //       },
    //       {
    //         "communicationRequestIdentifier": "http://sni.com.sa/communicationrequest/CommReq_306278",
    //         "communicationCategory": "instruction",
    //         "communicationContent": [
    //           {
    //             "contentString": "Please provide an updated lab report including HbAIC, LFT and Lipid profiles."
    //           }
    //         ],
    //         "communicationAbout": "http://141.147.130.248/authorization/req_24284"
    //       }
    //     ]
    //   }
    // }
    if (result) {
      setTimeout(() => {
        this.setState({ pollCommLoading: false });
      }, 500);
      let { data } = result;
      let { success, error, BundleID, communicationRequests } = data;

      if (success) {
        this.getAllVisits();
        // this.getAllAuthInfo();
        if (communicationRequests && communicationRequests.length > 0) {
          this.handleAddCommunicationRequestInfo(communicationRequests);
        }
      } else {
        console.log("error in polling");
        console.log(error);
        console.log("----------");
      }
    }
  };
  handleAddCommunicationRequestInfo = async (communicationRequests) => {
    let Response = await axios.post(
      KayanURL + "api/KSA/RCM/patient/addCommunicationRequest",
      {
        data: communicationRequests,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      console.log(data);
      if (data) {
        if (data.success) {
          this.setState({ pollCommMsg: "Done" });
          setTimeout(() => {
            this.setState({ pollCommMsg: "" });
          }, 1000);
        } else {
          console.log(
            "error in update or add the authorization response of a visit:",
            data.error
          );
          this.setState({ success: false /* , error: data.error */ });
        }
      }
    }
  };
  handleDownload = (attachmentData, fileName) => {
    try {
      const binaryData = atob(attachmentData);
      const bytes = new Uint8Array(binaryData.length);
      for (let i = 0; i < binaryData.length; i++) {
        bytes[i] = binaryData.charCodeAt(i);
      }

      const blob = new Blob([bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  render() {
    let {
      allvisits,
      errorsRow,
      authitemsRows,
      visitNeedApproval,
      addDiagnosis,
      editClaim,
      filteredPriceList,
      AllAprovalForResubmission,
      proceduresSeq,
      vitalSignSelectArray,
      procedure,
      communicationError,
      allCommRequestInfo,
      allAuthInfo,
    } = this.state;
    let visitRows, authOption;
    let commRequest;
    console.log("--------------------", procedure);

    let procedureDiscount, procedurePrice, priceAfterDiscount, procedureTax;

    if (filteredPriceList && filteredPriceList.length > 0) {
      procedureDiscount = parseInt(filteredPriceList[0].discount);
      procedurePrice = parseInt(filteredPriceList[0].price);
      procedureTax = parseInt(
        (
          parseInt(filteredPriceList[0].price) *
          this.state.procedureQuantity *
          (1 - parseInt(filteredPriceList[0].discount) / 100) *
          0.15
        ).toFixed(2)
      );
      priceAfterDiscount =
        parseInt(filteredPriceList[0].price) *
        this.state.procedureQuantity *
        (1 - parseInt(filteredPriceList[0].discount) / 100);
      // console.log(procedureDiscount, 'd', priceAfterDiscount, "A", procedurePrice, 'p', procedureTax, 't',filteredPriceList)
    }
    let visitStatus, authorizationStatus, color;
    if (allvisits && allvisits.length > 0) {
      visitRows = allvisits.map((element, index) => {
        if (element.visitstatus === "1") {
          visitStatus = "Not Started";
        } else if (element.visitstatus === "2") {
          visitStatus = "Started";
        } else if (element.visitstatus === "3") {
          visitStatus = "Pending";
        } else if (element.visitstatus === "4") {
          visitStatus = "Ended";
        }
        if (element.authorizationstatus === "1") {
          authorizationStatus = "Pending";
          color = "grey";
          authOption = "Auth";
        } else if (element.authorizationstatus === "2") {
          authorizationStatus = "Faild";
          color = "red";
          authOption = "Auth";
        } else if (element.authorizationstatus === "3") {
          authorizationStatus = "Complete";
          color = "green";
          /* authOption = ""; */
          authOption = "Auth";
        } else if (element.authorizationstatus === "4") {
          authorizationStatus = "Queued";
          color = "yellow";
        } else if (element.authorizationstatus === "cancelled") {
          authorizationStatus = "Cancelled";
          color = "black";
        }
        let count = 0;
        if (allCommRequestInfo && allCommRequestInfo.length > 0) {
          if (allAuthInfo && allAuthInfo.length > 0) {
            let authObject = allAuthInfo.find((x) => x.visitid === element.id);
            // console.log(authObject, 'auth obj')
            if (authObject) {
              commRequest = allCommRequestInfo.filter(
                (e) =>
                  e.communicationabout ===
                  authObject.authorizationrequestidentifier
              );
              if (commRequest && commRequest.length > 0) {
                let countArray = commRequest.filter(
                  (e) => e.acknowledgmentstatus === "Not replyed yet"
                );
                count = countArray.length;
              }
            }
          }
        }
        console.log(commRequest, "new");
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <a
                style={{
                  cursor: "pointer",
                  width: "10px ",
                  height: "10px",
                  backgroundColor: color,

                  padding: "6px 9px",
                  borderRadius: "50%",
                  color: color == "yellow" ? "black" : "white",
                }}
                onClick={() => this.getAllAuthorizationInfo(element)}
              >
                {element.id}
              </a>
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.identifier}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.firstname} {element.lastname}
            </TableCell>
            {/*  <TableCell align="center" style={{ fontSize: "small" }}>
              {element.invoicenumber}
            </TableCell> */}
            <TableCell align="center" style={{ fontSize: "small" }}>
              {visitStatus}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.visitstartdate}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {authorizationStatus}
            </TableCell>
            {commRequest && commRequest.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {`(${count}) Communication Request Not Replyed Yet`}
              </TableCell>
            ) : null}
          </TableRow>
        );
      });
    }

    let totalSum = 0;
    let allproceduresRows = [];
    let allDiagnosisRows = [];
    // let relatedDiagnosis = [];
    let totalRows = [];
    let supportingInformationTable = [];
    let authorizationstatus;
    let adjucationoutcome;
    if (visitNeedApproval) {
      let { allprocedures, diagnosis, supportinginformation, totals } =
        visitNeedApproval;
      // console.log(allprocedures, "pp")
      authorizationstatus = visitNeedApproval["authorizationstatus"];
      adjucationoutcome = visitNeedApproval["adjucationoutcome"];
      if (totals && totals.length > 0) {
        totalRows = totals.map((adj, i) => {
          return (
            <TableRow key={i}>
              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {adj.category}
              </TableCell>{" "}
              <TableCell align="center" style={{ fontSize: "small" }}>
                {adj.amount}
              </TableCell>
            </TableRow>
          );
        });
      }

      if (allprocedures && allprocedures.length > 0) {
        allproceduresRows = allprocedures.map((element, index) => {
          console.log(element);
          let { diagnosisSequence, informationSequence } = element;
          let { price, discount, tax, quantity, factor, net } = element;
          /*   // console.log(element.totals, 'tot')
          let factor = 1;
          let Net
          if (discount != 0) {
            factor = 1 - (parseFloat(discount) / 100);
          }
          Net = (factor * quantity * price) + tax_calculated; */
          totalSum += parseFloat(net);
          return (
            <TableRow key={index}>
              {this.state.resubmissionFlag ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  <>
                    <Checkbox
                      checked={proceduresSeq.includes(index + 1)}
                      name="selectProcedure"
                      onChange={(e) => this.handleCheckBox(e, index)}
                    />{" "}
                  </>
                </TableCell>
              ) : null}
              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {element.type}{" "}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.code}{" "}
              </TableCell>
              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {element.description}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.quantity}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.price}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.discount}%
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.tax}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.deduction}%
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.patientshare}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.net}
              </TableCell>

              {/**tooth */}

              {element.type == "dental" && element.toothNumber ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {
                    /* this.state.showToothNumber ? */ element.toothNumber +
                    "/" +
                    element.toothDescription /* : " " */
                  }
                </TableCell>
              ) : (
                <TableCell
                  align="center"
                  style={{ fontSize: "small" }}
                ></TableCell>
              )}

              {(diagnosisSequence && diagnosisSequence.length > 0) ||
                editClaim ? (
                <>
                  {editClaim &&
                    this.state.allDiagnosisSelect &&
                    this.state.allDiagnosisSelect.length > 0 ? (
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      <div
                        style={{
                          width: "100%",
                          margin: "10px auto",
                        }}
                      >
                        <Multiselect
                          key={this.state.diagKey}
                          placeholder="Diagnosis"
                          options={this.state.allDiagnosisSelect}
                          selectedValues={
                            diagnosisSequence
                              ? visitNeedApproval.allprocedures[
                                index
                              ].diagnosisSequence.map(
                                (sequence) =>
                                  this.state.allDiagnosisSelect[sequence - 1]
                              )
                              : null
                          }
                          onSelect={(selectedList) => {
                            this.SelectDiagnosisForProcedure(
                              selectedList,
                              index
                            );
                          }}
                          onRemove={(selectedList, removedItem) => {
                            this.RemoveDiagnosisForProcedure(
                              selectedList,
                              removedItem,
                              index
                            );
                          }}
                          displayValue="view"
                        />
                      </div>
                    </TableCell>
                  ) : diagnosisSequence && diagnosisSequence.length > 0 ? (
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {diagnosisSequence.toString()}
                    </TableCell>
                  ) : (
                    <TableCell
                      align="center"
                      style={{ fontSize: "small" }}
                    ></TableCell>
                  )}
                </>
              ) : (
                <TableCell
                  align="center"
                  style={{ fontSize: "small" }}
                ></TableCell>
              )}

              {(informationSequence && informationSequence.length > 0) ||
                editClaim ? (
                <>
                  {editClaim &&
                    this.state.vitalSignSelectArray &&
                    this.state.vitalSignSelectArray.length > 0 ? (
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      <div
                        style={{
                          width: "100% ",
                          margin: "10px auto",
                        }}
                      >
                        <Multiselect
                          key={this.state.key}
                          placeholder="Supporting Informatiom"
                          options={this.state.vitalSignSelectArray}
                          selectedValues={
                            informationSequence
                              ? visitNeedApproval.allprocedures[
                                index
                              ].informationSequence.map(
                                (sequence) =>
                                  vitalSignSelectArray[sequence - 1]
                              )
                              : null
                          }
                          onSelect={(selectedList) => {
                            this.SelectCategoryForProcedure(
                              selectedList,
                              index
                            );
                          }}
                          onRemove={(selectedList, removedItem) => {
                            this.RemoveCategoryForProcedure(
                              selectedList,
                              removedItem,
                              index
                            );
                          }}
                          displayValue="display"
                        />
                      </div>
                    </TableCell>
                  ) : informationSequence && informationSequence.length > 0 ? (
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {informationSequence.toString()}
                    </TableCell>
                  ) : (
                    <TableCell
                      align="center"
                      style={{ fontSize: "small" }}
                    ></TableCell>
                  )}
                </>
              ) : (
                <TableCell
                  align="center"
                  style={{ fontSize: "small" }}
                ></TableCell>
              )}

              {(authorizationstatus && authorizationstatus == "3") ||
                (authorizationstatus == "cancelled" &&
                  errorsRow.length == 0 &&
                  !this.state.queuedInfoFlag) ? (
                <TableCell
                  align="center"
                  style={{ fontSize: "small", textTransform: "capitalize" }}
                >
                  {element.outcome ? (
                    <TableRow align="center">
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        Outcome
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "small",
                          textTransform: "capitalize",
                        }}
                      >
                        {element.outcome}
                      </TableCell>
                    </TableRow>
                  ) : null}

                  {(authorizationstatus &&
                    authorizationstatus == "3" &&
                    (element.outcome == "rejected" ||
                      element.outcome == "partial")) ||
                    (authorizationstatus == "cancelled" &&
                      errorsRow.length == 0 &&
                      !this.state.queuedInfoFlag &&
                      (adjucationoutcome == "rejected" ||
                        adjucationoutcome == "partial")) ? (
                    <TableRow>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        Rejection Reason
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "small",
                          textTransform: "capitalize",
                        }}
                      >
                        {element.reason}
                      </TableCell>
                    </TableRow>
                  ) : null}

                  {(authorizationstatus &&
                    authorizationstatus == "3" &&
                    (element.outcome == "rejected" ||
                      element.outcome == "partial")) ||
                    (authorizationstatus == "cancelled" &&
                      errorsRow.length == 0 &&
                      !this.state.queuedInfoFlag &&
                      (adjucationoutcome == "rejected" ||
                        adjucationoutcome == "partial")) ? (
                    <TableRow>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        Denail Code
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.denailCode}
                      </TableCell>
                    </TableRow>
                  ) : null}

                  {(authorizationstatus && authorizationstatus == "3") ||
                    (authorizationstatus == "cancelled" &&
                      errorsRow.length == 0 &&
                      !this.state.queuedInfoFlag) ? (
                    <>
                      {element.adjudications &&
                        element.adjudications.length > 0 ? (
                        <TableRow>
                          <TableCell
                            colSpan={2}
                            align="center"
                            style={{ fontSize: "small" }}
                            fontWeight={"bold"}
                          >
                            Adjudications Outcome
                          </TableCell>
                        </TableRow>
                      ) : null}
                      {element.adjudications && element.adjudications.length > 0
                        ? element.adjudications.map((adj, i) => {
                          return (
                            <TableRow align="center" key={i}>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: "small",
                                  textTransform: "capitalize",
                                }}
                              >
                                {adj.category}
                              </TableCell>{" "}
                              <TableCell
                                align="center"
                                style={{ fontSize: "small" }}
                              >
                                {adj.amount}
                              </TableCell>
                            </TableRow>
                          );
                        })
                        : null}
                    </>
                  ) : null}
                </TableCell>
              ) : null}
              {editClaim ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  <a
                    onClick={() => {
                      this.handleDeleteProcedure(index);
                    }}
                  >
                    <DeleteIcon style={{ cursor: "pointer" }} />
                  </a>
                </TableCell>
              ) : null}
            </TableRow>
          );
        });
      }

      if (diagnosis && diagnosis.length > 0) {
        allDiagnosisRows = diagnosis.map((element, index) => {
          return (
            <TableRow key={index}>
              {editClaim && this.state.calimDefaultValue === "institutional" ? (
                <>
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    <Checkbox
                      name="onAdmission"
                      onChange={(e) => this.handleCheckBox(e, index)}
                    />{" "}
                  </TableCell>
                </>
              ) : null}
              <TableCell align="center" style={{ fontSize: "small" }}>
                {index + 1}{" "}
              </TableCell>
              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {element.type}{" "}
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.code}{" "}
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {element.description}{" "}
              </TableCell>
              {editClaim ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  <a
                    onClick={() => {
                      this.handleDeleteDiagnosis(index);
                    }}
                  >
                    <DeleteIcon style={{ cursor: "pointer" }} />
                  </a>
                </TableCell>
              ) : null}
            </TableRow>
          );
        });
        //console.log(" allDiagnosisRows", allDiagnosisRows);
      }

      if (supportinginformation && supportinginformation.length > 0) {
        supportingInformationTable = supportinginformation.map(
          (info, index) => {
            let keys = Object.keys(info);
            let value;

            if (keys[0] == "chief-complaint") {
              value = info[keys[0]]["text"];
            } else if (keys[0] == "attachment") {
              value = info[keys[0]]["title"];
            } else {
              value = info[[keys[0]]];
            }

            return (
              <TableRow key={index}>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {index + 1}{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{ fontSize: "small", textTransform: "capitalize" }}
                >
                  {keys[0]}
                </TableCell>

                <TableCell align="center" style={{ fontSize: "small" }}>
                  {value}
                </TableCell>
                {editClaim ? (
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    <a
                      onClick={() => {
                        this.handleDeleteVital(index);
                      }}
                    >
                      <DeleteIcon style={{ cursor: "pointer" }} />
                    </a>
                  </TableCell>
                ) : null}
              </TableRow>
            );
          }
        );
      }

      let year = new Date().getFullYear();
      if (visitNeedApproval) {
        let dateSplit = visitNeedApproval.birthdate.split("-");
        let birthYear = dateSplit[0];
        let age = year - birthYear + " years";
        visitNeedApproval.age = age;
      }
    }

    let height;
    if (allproceduresRows && allproceduresRows.length > 0) {
      height = "600px";
    } else if (errorsRow && errorsRow.length > 0) {
      height = "300px";
    } else if (authitemsRows && authitemsRows.length > 0) {
      height = "500px";
    }
    let communicationErrorsRow = [];
    if (communicationError && communicationError.length > 0) {
      communicationErrorsRow = communicationError.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.message}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.expression}
            </TableCell>
          </TableRow>
        );
      });
    }
    return (
      <Box height={60}>
        <div>
          <div
            style={{
              textAlign: "center",
              margin: "auto",
              boxShadow: "1px solid grey",
              padding: "15px",
              boxShadow:
                "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
              borderRadius: "10px",
              marginTop: "50px",
              width: "95%",
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ textAlign: "left", marginLeft: "30px" }}
            >
              Pre-Authorization
            </Typography>
            <div
              style={{
                margin: "auto",

                padding: "20px",
                marginTop: "10px",
                width: "95%",
              }}
            >
              <Accordion
                defaultActiveKey="0"
                style={{
                  margin: "auto",
                  paddingBottom: "20px",
                  width: "80%",
                }}
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span style={{ color: "grey" }}>Search Claim</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <Row>
                      <Col>
                        <FormControl fullWidth sx={{ mb: 3 }}>
                          <TextField
                            InputLabelProps={{
                              sx: { fontSize: "small" },
                              shrink: this.state.identifier ? true : false,
                            }}
                            inputProps={{ sx: { padding: "9px" } }}
                            name="identifier"
                            label="Identifier"
                            variant="outlined"
                            value={this.state.identifier}
                            onChange={this.HandleInputSearchRequestTextChange}
                          />
                        </FormControl>
                        <FormControl sx={{ mb: 3 }} style={{ width: "100%" }}>
                          <InputLabel
                            id="insurance"
                            style={{ fontSize: "small" }}
                          >
                            TPA
                          </InputLabel>
                          <Select
                            required
                            labelId="tpa"
                            name="tpa"
                            label="TPA"
                            onChange={this.HandleInputSearchRequestTextChange}
                            value={this.state.tpa ? this.state.tpa : ""}
                            style={{ height: "45px" }}
                          >
                            <MenuItem
                              value="7001463160"
                              name="GlobeMed"
                              style={{ fontSize: "small" }}
                            >
                              GlobeMed Saudi
                            </MenuItem>
                            <MenuItem
                              value="7001604342"
                              name="Mednet"
                              style={{ fontSize: "small" }}
                            >
                              Mednet
                            </MenuItem>

                            <MenuItem
                              value="7001599658"
                              name="Totalcare"
                              style={{ fontSize: "small" }}
                            >
                              Totalcare
                            </MenuItem>
                            <MenuItem
                              value="7001580856"
                              name="Nextcare"
                              style={{ fontSize: "small" }}
                            >
                              Nextcare
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Col>
                      <Col>
                        <FormControl fullWidth sx={{ mb: 3 }}>
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" } }}
                            inputProps={{ sx: { padding: "9px" } }}
                            name="name"
                            label="Patient Name"
                            value={this.state.name ? this.state.name : ""}
                            variant="outlined"
                            onChange={this.HandleInputSearchRequestTextChange}
                          />
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 3 }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              sx={{
                                "& .MuiInputBase-input": {
                                  height: "8px",
                                },
                                ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root":
                                {
                                  fontSize: "small",
                                },
                              }}
                              name="visitstartdate"
                              label="Visit Date"
                              value={
                                this.state.visitstartdate
                                  ? this.state.visitstartdate
                                  : ""
                              }
                              onChange={(date) =>
                                this.HandleDateChange({
                                  name: "visitstartdate",
                                  value: date,
                                })
                              }
                            />
                          </LocalizationProvider>
                        </FormControl>
                      </Col>
                      <Col>
                        <FormControl sx={{ mb: 3 }} style={{ width: "100%" }}>
                          <InputLabel
                            id="insurance"
                            style={{ fontSize: "small" }}
                          >
                            Insurance Company
                          </InputLabel>
                          <Select
                            required
                            labelId="insurance"
                            name="payerid"
                            label="Insurance Company"
                            value={this.state.payerid ? this.state.payerid : ""}
                            onChange={this.HandleInputSearchRequestTextChange}
                            style={{ height: "45px" }}
                          >
                            <MenuItem
                              value="INS-FHIR"
                              name="Pseudo Payer"
                              style={{ fontSize: "small" }}
                            >
                              Pseudo Payer
                            </MenuItem>
                            <MenuItem
                              value="7001571327"
                              style={{ fontSize: "small" }}
                            >
                              Bupa Arabia for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7000911508"
                              style={{ fontSize: "small" }}
                            >
                              The Cooperative Company for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7001593321"
                              style={{ fontSize: "small" }}
                            >
                              Al-Rajhi Company for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7001548317"
                              style={{ fontSize: "small" }}
                            >
                              The Mediterranean and Gulf Cooperative Insurance
                              and Reinsurance Company (MedGulf)
                            </MenuItem>
                            <MenuItem
                              value="7001539720"
                              style={{ fontSize: "small" }}
                            >
                              Saudi Arabian Cooperative Insurance Company
                              (SAICO) *
                            </MenuItem>
                            <MenuItem
                              value="7001532279"
                              style={{ fontSize: "small" }}
                            >
                              Gulf Union Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001607683"
                              style={{ fontSize: "small" }}
                            >
                              AXA Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001519912"
                              style={{ fontSize: "small" }}
                            >
                              Malath Cooperative Insurance and Reinsurance
                              Company
                            </MenuItem>
                            <MenuItem
                              value="7001527667"
                              style={{ fontSize: "small" }}
                            >
                              Arabia Insurance Cooperative Company
                            </MenuItem>
                            <MenuItem
                              value="7001523724"
                              style={{ fontSize: "small" }}
                            >
                              Salama Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001703672"
                              style={{ fontSize: "small" }}
                            >
                              Saudi Enaya Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001625891"
                              style={{ fontSize: "small" }}
                            >
                              Solidarity Saudi Takaful Company
                            </MenuItem>
                            <MenuItem
                              value="7001626717"
                              style={{ fontSize: "small" }}
                            >
                              Amana Cooperative Insurance Company *
                            </MenuItem>
                            <MenuItem
                              value="7001534275"
                              style={{ fontSize: "small" }}
                            >
                              The National Company for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7001537161"
                              style={{ fontSize: "small" }}
                            >
                              Allianz Saudi Fransi Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001526578"
                              style={{ fontSize: "small" }}
                            >
                              Saudi United Cooperative Insurance Company (Wala)
                            </MenuItem>
                            <MenuItem
                              value="7001535694"
                              style={{ fontSize: "small" }}
                            >
                              Allied Cooperative Insurance Group (ACIG)
                            </MenuItem>
                            <MenuItem
                              value="7001609481"
                              style={{ fontSize: "small" }}
                            >
                              Global Company for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7001641419"
                              style={{ fontSize: "small" }}
                            >
                              Gulf General Company for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7001544472"
                              style={{ fontSize: "small" }}
                            >
                              Al Sagr Cooperative Insurance Company *
                            </MenuItem>
                            <MenuItem
                              value="7001549059"
                              style={{ fontSize: "small" }}
                            >
                              Trade Union Cooperative Insurance Company *
                            </MenuItem>
                            <MenuItem
                              value="7001617724"
                              style={{ fontSize: "small" }}
                            >
                              Buruj Cooperative Insurance Company *
                            </MenuItem>
                            <MenuItem
                              value="7001527816"
                              style={{ fontSize: "small" }}
                            >
                              Arabian Shield Cooperative Insurance Company *
                            </MenuItem>
                            <MenuItem
                              value="7001559389"
                              style={{ fontSize: "small" }}
                            >
                              United Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001727200"
                              style={{ fontSize: "small" }}
                            >
                              Tokyo Marine Development Corporation
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Col>
                    </Row>
                    <div style={{ width: "100%", display: "flex" }}>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "rgb(97 110 120",
                          marginRight: "10px",
                          width: "20%",
                          fontSize: "11px",
                        }}
                        onClick={(e) => this.handleSearchRequest(e)}
                      >
                        search
                      </Button>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "rgb(97 110 120",
                          transition: "background-color 0.4s, color 0.4s",
                          width: "30%",
                          marginRight: "10px",
                          fontSize: "10px",
                        }}
                        onClick={(e) => this.handlePollingRequest(e)}
                      >
                        {this.state.pollLoading
                          ? "Loading..."
                          : " Authorization Response Polling"}
                      </Button>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "rgb(97 110 120",
                          transition: "background-color 0.4s, color 0.4s",
                          width: "30%",
                          fontSize: "11px",
                        }}
                        onClick={(e) =>
                          this.handlePollingCommunicationRequest(e)
                        }
                      >
                        {this.state.pollCommLoading
                          ? "Loading..."
                          : "Comm_Req Poll"}
                      </Button>
                    </div>
                    {this.state.pollCommMsg ? (
                      <>
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                          style={{
                            textAlign: "center",
                            marginTop: "20px",
                            color: "green",
                            fontSize: "17px",
                          }}
                        >
                          {this.state.pollCommMsg}
                        </Typography>
                      </>
                    ) : null}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              {this.state.searchRequestSent && !this.state.searchDone ? (
                <CircularProgress />
              ) : !this.state.searchRequestSent &&
                this.state.allvisits &&
                this.state.allvisits.length > 0 ? (
                <>
                  <TableContainer
                    component={Paper}
                    style={{ margin: "0 auto 20px" }}
                  >
                    <Table aria-label="simple table">
                      <TableHead style={{ backgroundColor: "#fafafa" }}>
                        <TableRow style={{ textAlign: "center" }}>
                          <TableCell align="center">Visit Number</TableCell>
                          <TableCell align="center">
                            Patient Identifier
                          </TableCell>
                          <TableCell align="center">Patient Name</TableCell>
                          {/*  <TableCell align="center">Invoice Number</TableCell> */}
                          <TableCell align="center">Visit Status</TableCell>
                          <TableCell align="center">Visit Date</TableCell>
                          <TableCell align="center">Approval Status</TableCell>
                          {this.state.commRequestExist ? (
                            <TableCell align="center">
                              Communication Request
                            </TableCell>
                          ) : null}
                        </TableRow>
                      </TableHead>
                      <TableBody>{visitRows}</TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : this.state.allvisits && this.state.allvisits.length == 0 ? (
                <>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    style={{ textAlign: "center", marginTop: "30px" }}
                  >
                    There are no visits need approval!
                  </Typography>
                </>
              ) : null}

              {this.state.errMsg ? (
                <>
                  <Typography style={{ textAlign: "center", color: "red" }}>
                    {this.state.errMsg}
                  </Typography>
                </>
              ) : null}
              {this.state.viewPreAuthInfoModal ? (
                <Modal
                  open={this.state.viewPreAuthInfoModal}
                  onClose={this.handleClosePreAuthInfo}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={style}
                    style={{
                      width: "95%",
                      height: "700px",
                      overflowY: "scroll",
                    }}
                  >
                    <Row style={{ marginTop: "10px" }}>
                      <Col xs={2}>
                        {" "}
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "rgb(97 110 120",
                            border: "1px ridge gray",
                            width: "70%",
                            color: "white",
                            fontSize: "smaller",
                            margin: "auto",
                            transition: "background-color 0.4s, color 0.4s",
                            width: "100%",
                            fontSize: "11px",
                          }}
                          onClick={(e) => {
                            this.setState({
                              editClaim: true,
                              addDiagnosis:
                                visitNeedApproval["diagnosis"] &&
                                  visitNeedApproval["diagnosis"].length > 0
                                  ? false
                                  : true,
                              addProcedure:
                                visitNeedApproval["allprocedures"] &&
                                  visitNeedApproval["allprocedures"].length > 0
                                  ? false
                                  : true,
                              addVital:
                                visitNeedApproval["supportinginformation"] &&
                                  visitNeedApproval["supportinginformation"]
                                    .length > 0
                                  ? false
                                  : true,
                            });
                            this.handleSave(e);
                          }}
                        >
                          {editClaim
                            ? this.state.saveLoading
                              ? "Loading..."
                              : "save"
                            : "Edit"}
                        </Button>
                      </Col>
                      <Col xs={2}>
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "rgb(97 110 120)",
                            border: "1px ridge gray",
                            width: "100%",
                            color: "white",
                            fontSize: "smaller",
                            margin: "auto",
                            transition: "background-color 0.4s, color 0.4s",
                            fontSize: "11px",
                          }}
                          onClick={(e) =>
                            this.AuthorizationRequest(e, visitNeedApproval)
                          }
                        >
                          {this.state.authLoading
                            ? "Loading..."
                            : " Approval Request"}
                        </Button>
                      </Col>
                      <Col xs={2}>
                        {authorizationstatus == "3" ? (
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: "rgb(97 110 120",
                              border: "1px ridge gray",
                              cursor: "pointer",
                              color: "white",
                              fontSize: "smaller",
                              textAlign: "left",
                              width: "100%",
                              fontSize: "11px",
                            }}
                            onClick={(e) => {
                              this.setState({
                                resubmissionFlag: true,
                                proceduresForResubmission: [],
                                proceduresSeq: [],
                              });
                            }}
                          >
                            Resubmission
                          </Button>
                        ) : (
                          <Button
                            disabled
                            variant="contained"
                            style={{
                              backgroundColor: "rgb(171 184 194)",
                              border: "1px ridge rgb(171 184 194)",
                              cursor: "pointer",
                              color: "white",
                              fontSize: "smaller",
                              textAlign: "left",
                              width: "100%",
                              fontSize: "11px",
                            }}
                          >
                            Resubmission
                          </Button>
                        )}
                      </Col>
                      {(authorizationstatus && authorizationstatus == "2") ||
                        (authorizationstatus && authorizationstatus == "3") ||
                        (authorizationstatus && authorizationstatus == "4") ||
                        (authorizationstatus &&
                          authorizationstatus == "cancelled") ? (
                        <Col xs={2}>
                          <Button
                            disabled={
                              authorizationstatus === "1" ||
                                authorizationstatus === "cancelled"
                                ? true
                                : false
                            }
                            variant="contained"
                            style={{
                              backgroundColor:
                                authorizationstatus === "1" ||
                                  authorizationstatus === "cancelled"
                                  ? "rgb(171 184 194)"
                                  : "rgb(97 110 120",
                              border:
                                authorizationstatus === "1" ||
                                  authorizationstatus === "cancelled"
                                  ? "1px ridge rgb(171 184 194)"
                                  : "1px ridge rgb(97 110 120",
                              cursor: "pointer",
                              color: "white",
                              fontSize: "smaller",
                              textAlign: "left",
                              transition: "background-color 0.4s, color 0.4s",
                              width: "100%",
                              fontSize: "11px",
                            }}
                            onClick={(e) =>
                              this.handleCansulation(e, visitNeedApproval)
                            }
                          >
                            {this.state.cancelLoading
                              ? "Loading..."
                              : "Cancellation"}
                          </Button>
                          {this.state.cancelErrors &&
                            this.state.cancelErrors.length > 0 ? (
                            <>
                              <h6
                                style={{
                                  fontSize: "12px",
                                  color: "red",
                                  margin: "5px auto",
                                }}
                              >
                                {this.state.cancelErrors[0].errorMsg}
                              </h6>
                            </>
                          ) : null}
                        </Col>
                      ) : null}
                      {(authorizationstatus && authorizationstatus == "2") ||
                        (authorizationstatus && authorizationstatus == "3") ||
                        (authorizationstatus && authorizationstatus == "4") ||
                        (authorizationstatus &&
                          authorizationstatus == "cancelled") ? (
                        <Col xs={2}>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: "rgb(97 110 120",
                              border: "1px ridge gray",
                              width: "100%",
                              color: "white",
                              fontSize: "smaller",
                              textAlign: "left",
                              transition: "background-color 0.4s, color 0.4s",
                              fontSize: "11px",
                            }}
                            onClick={(e) =>
                              this.handleCheck(e, visitNeedApproval)
                            }
                          >
                            {this.state.statusLoading
                              ? "Loading..."
                              : "Check Status"}
                          </Button>
                        </Col>
                      ) : null}
                      {(authorizationstatus && authorizationstatus == "2") ||
                        (authorizationstatus && authorizationstatus == "3") ||
                        (authorizationstatus && authorizationstatus == "4") ||
                        (authorizationstatus &&
                          authorizationstatus == "cancelled") ? (
                        <Col xs={2}>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: "rgb(97 110 120",
                              border: "1px ridge gray",
                              width: "100%",
                              color: "white",
                              fontSize: "smaller",
                              textAlign: "left",
                              fontSize: "11px",
                            }}
                            onClick={() => {
                              this.setState({
                                communicationHistoryModalOpen: true,
                              });
                              this.getAllCommunicationRequestInfoByReqIdentefier();
                              this.getAllCommunicationTransactionInfoByReqIdentefier();
                            }}
                          >
                            Communication History
                          </Button>
                        </Col>
                      ) : null}
                    </Row>
                    {this.state.authErrorMsg ? (
                      <p
                        style={{
                          color: "red",
                          textAlign: "center",
                          fontSize: "13px",
                          marginTop: "20px",
                        }}
                      >
                        {this.state.authErrorMsg}
                      </p>
                    ) : null}
                    {this.state.communicationHistoryModalOpen ? (
                      <>
                        <Modal
                          open={this.state.communicationHistoryModalOpen}
                          onClose={this.handleCloseCommunicationHistoryModal}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <Box
                            sx={styleModal}
                            style={{
                              width: "70%",
                              height: "600px",
                              overflowY: "auto",
                            }}
                          >
                            <Row>
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                                style={{ textAlign: "left", marginTop: "5px" }}
                              >
                                Communication Requests
                              </Typography>
                              {this.state.communicationRequestLoading ? (
                                <div style={{ textAlign: "center" }}>
                                  <CircularProgress />
                                </div>
                              ) : this.state.communicationReqSuccess &&
                                this.state.requestData &&
                                this.state.requestData.length > 0 ? (
                                <>
                                  <TableContainer
                                    component={Paper}
                                    style={{
                                      margin: "auto",
                                      width: "100%",
                                      // height: "300px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    <Table aria-label="simple table">
                                      <TableHead
                                        style={{ backgroundColor: "#fafafa" }}
                                      >
                                        <TableRow
                                          style={{ textAlign: "center" }}
                                        >
                                          <TableCell align="center">
                                            ID
                                          </TableCell>
                                          <TableCell align="center">
                                            Communication Request Identifier
                                          </TableCell>
                                          <TableCell align="center">
                                            Communication Category
                                          </TableCell>
                                          <TableCell align="center">
                                            Communication About
                                          </TableCell>
                                          <TableCell align="center">
                                            Content String
                                          </TableCell>
                                          <TableCell align="center">
                                            Acknowledgment Status
                                          </TableCell>
                                          <TableCell align="center">
                                            Reply
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {this.state.requestData.map(
                                          (ele, index) => {
                                            return (
                                              <TableRow>
                                                <TableCell align="center">
                                                  {ele.id}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.identifier}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.communicationcategory}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.communicationabout}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.contentstring}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.acknowledgmentstatus}
                                                </TableCell>
                                                <TableCell align="center">
                                                  <a
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={(e) => {
                                                      this.setState({
                                                        communicationModalOpen: true,
                                                        communicationCategory:
                                                          ele.communicationcategory,
                                                        basedOnValue:
                                                          ele.identifier,
                                                        communicationAboutValue:
                                                          ele.communicationabout,
                                                        idValue: ele.id,
                                                      });
                                                    }}
                                                  >
                                                    <ReplyIcon
                                                      style={{
                                                        color: "#6262e7",
                                                      }}
                                                    />
                                                  </a>
                                                </TableCell>
                                              </TableRow>
                                            );
                                          }
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </>
                              ) : (
                                <>
                                  <p
                                    style={{
                                      color: "red",
                                      textAlign: "center",
                                      fontSize: "13px",
                                    }}
                                  >
                                    There is no communication requests !
                                  </p>
                                </>
                              )}
                            </Row>
                            <hr />
                            <Row>
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                                style={{ textAlign: "left", marginTop: "5px" }}
                              >
                                Communication Transactions
                              </Typography>
                              <div style={{ width: "30%", marginLeft: "auto" }}>
                                <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "rgb(97 110 120",
                                    border: "1px ridge gray",
                                    width: "100%",
                                    color: "white",
                                    fontSize: "smaller",
                                    textAlign: "left",
                                    fontSize: "11px",
                                  }}
                                  onClick={(e) => {
                                    this.setState({
                                      communicationModalOpen: true,
                                    });
                                  }}
                                >
                                  Send Unsolicited Communication
                                </Button>
                              </div>
                              {this.state.communicationTransactionLoading ? (
                                <div style={{ textAlign: "center" }}>
                                  <CircularProgress />
                                </div>
                              ) : this.state.communicationTransactionSuccess &&
                                this.state.transactionsData &&
                                this.state.transactionsData.length > 0 ? (
                                <>
                                  <TableContainer
                                    component={Paper}
                                    style={{
                                      margin: "10px auto",
                                      width: "100%",
                                      // height: "300px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    <Table aria-label="simple table">
                                      <TableHead
                                        style={{ backgroundColor: "#fafafa" }}
                                      >
                                        <TableRow
                                          style={{ textAlign: "center" }}
                                        >
                                          <TableCell align="center">
                                            ID
                                          </TableCell>
                                          <TableCell align="center">
                                            Request Identifier
                                          </TableCell>
                                          <TableCell align="center">
                                            Communication Category
                                          </TableCell>
                                          <TableCell align="center">
                                            Content
                                          </TableCell>
                                          <TableCell align="center">
                                            Communication Type
                                          </TableCell>
                                          <TableCell align="center">
                                            Acknowledgment Status
                                          </TableCell>
                                          <TableCell align="center">
                                            Based On
                                          </TableCell>
                                          <TableCell align="center">
                                            Attachment
                                          </TableCell>
                                          <TableCell align="center">
                                            Error
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {this.state.transactionsData.map(
                                          (ele, index) => {
                                            return (
                                              <TableRow>
                                                <TableCell align="center">
                                                  {ele.id}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.requestidentifier}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.communicationcategory}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.content}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.communicationtype}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.acknowledgmentstatus}
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {ele.basedon}
                                                </TableCell>
                                                <TableCell align="center">
                                                  {ele.attachment ? (
                                                    <a
                                                      href="#"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        this.handleDownload(
                                                          ele.attachment,
                                                          "attachment.pdf"
                                                        );
                                                      }}
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      <FileDownloadIcon
                                                        style={{
                                                          color: "#6262e7",
                                                        }}
                                                      />
                                                    </a>
                                                  ) : null}
                                                </TableCell>
                                                {ele.communicationerror &&
                                                  ele.communicationerror.length >
                                                  0 ? (
                                                  <TableCell
                                                    align="center"
                                                    style={{
                                                      textTransform:
                                                        "capitalize",
                                                    }}
                                                  >
                                                    <a
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={(e) => {
                                                        this.setState({
                                                          showError: true,
                                                          communicationTransactionErrors:
                                                            ele.communicationerror,
                                                        });
                                                      }}
                                                    >
                                                      <VisibilityIcon
                                                        style={{
                                                          color: "#6262e7",
                                                        }}
                                                      />
                                                    </a>
                                                  </TableCell>
                                                ) : (
                                                  <TableCell></TableCell>
                                                )}
                                              </TableRow>
                                            );
                                          }
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </>
                              ) : (
                                <>
                                  <p
                                    style={{
                                      color: "red",
                                      textAlign: "center",
                                      fontSize: "13px",
                                    }}
                                  >
                                    There is no communication transactions !
                                  </p>
                                </>
                              )}
                            </Row>
                          </Box>
                        </Modal>
                      </>
                    ) : null}
                    {this.state.communicationModalOpen ? (
                      <>
                        <Modal
                          open={this.state.communicationModalOpen}
                          onClose={this.handleCloseCommunicationModal}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <Box
                            sx={styleModal}
                            style={{
                              width: "40%",
                              height:
                                this.state.communicationError &&
                                  this.state.communicationError.length > 0
                                  ? "600px"
                                  : "400px",
                            }}
                          >
                            <div style={{ width: "70%", margin: "auto" }}>
                              <FormControl style={{ width: "100%" }}>
                                <InputLabel
                                  id="Category"
                                  style={{ fontSize: "small" }}
                                >
                                  Category
                                </InputLabel>
                                <Select
                                  required
                                  labelId="Category"
                                  name="communicationCategory"
                                  label="Category"
                                  onChange={this.HandleCommunicationInputChange}
                                  style={{ height: "45px" }}
                                  value={
                                    this.state.communicationCategory
                                      ? this.state.communicationCategory
                                      : ""
                                  }
                                >
                                  <MenuItem
                                    value="alert"
                                    style={{ fontSize: "small" }}
                                  >
                                    Alert
                                  </MenuItem>
                                  <MenuItem
                                    value="notification"
                                    style={{ fontSize: "small" }}
                                  >
                                    Notification
                                  </MenuItem>
                                  <MenuItem
                                    value="reminder"
                                    style={{ fontSize: "small" }}
                                  >
                                    Reminder
                                  </MenuItem>
                                  <MenuItem
                                    value="instruction"
                                    style={{ fontSize: "small" }}
                                  >
                                    Instruction
                                  </MenuItem>
                                </Select>
                              </FormControl>
                              <FormControl
                                style={{ marginTop: "20px", width: "100%" }}
                              >
                                <TextField
                                  InputLabelProps={{
                                    sx: { fontSize: "small" },
                                  }}
                                  inputProps={{ sx: { padding: "10px" } }}
                                  type="text"
                                  name="content"
                                  label="Content"
                                  variant="outlined"
                                  multiline
                                  maxRows={4}
                                  value={
                                    this.state.content ? this.state.content : ""
                                  }
                                  onChange={this.HandleCommunicationInputChange}
                                />
                              </FormControl>
                              <div
                                style={{
                                  marginTop: "20px",
                                  border: "1px solid grey",
                                  padding: "10px",
                                  borderRadius: "5px",
                                }}
                              >
                                <input
                                  style={{
                                    display: "block",
                                    margin: "auto",
                                    marginRight: "5px",
                                  }}
                                  type="file"
                                  name="communicationAttachment"
                                  ref={this.fileInputRef}
                                  onChange={this.HandleCommunicationInputChange}
                                />
                              </div>
                            </div>

                            <Row>
                              <div
                                style={{
                                  width: "100%",
                                  marginTop: "20px",
                                  textAlign: "center",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "rgb(97 110 120",
                                    marginRight: "10px",
                                    transition:
                                      "background-color 0.4s, color 0.4s",
                                    width: "20%",
                                  }}
                                  onClick={(e) => this.handleSend(e)}
                                >
                                  {this.state.sendLoading
                                    ? "Loading..."
                                    : "Send"}
                                </Button>

                                <div></div>
                              </div>
                            </Row>
                            <Row>
                              {this.state.communicationError &&
                                this.state.communicationError.length > 0 ? (
                                <>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{
                                      textAlign: "center",
                                      marginTop: "10px",
                                    }}
                                  >
                                    Errors
                                  </Typography>
                                  <div
                                    style={{
                                      width: "100%",
                                      margin: "auto",
                                      height: "200px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    <TableContainer
                                      component={Paper}
                                      style={{
                                        margin: "auto",
                                        width: "100%",
                                      }}
                                    >
                                      <Table aria-label="simple table">
                                        <TableHead
                                          style={{ backgroundColor: "#fafafa" }}
                                        >
                                          <TableRow
                                            style={{ textAlign: "center" }}
                                          >
                                            <TableCell align="center">
                                              Message
                                            </TableCell>
                                            <TableCell align="center">
                                              Expression
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {communicationErrorsRow}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </div>
                                </>
                              ) : this.state.acknowledgmentStatus === "ok" ? (
                                <>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{
                                      textAlign: "center",
                                      marginTop: "5px",
                                      color: "green",
                                      fontSize: "13px",
                                    }}
                                  >
                                    The Communication Transaction Sent
                                    Successfully
                                  </Typography>
                                </>
                              ) : null}
                            </Row>
                          </Box>
                        </Modal>
                      </>
                    ) : null}
                    {this.state.showError ? (
                      <>
                        <Modal
                          open={this.state.showError}
                          onClose={this.handleCloseErrorModal}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <Box
                            sx={styleModal}
                            style={{
                              width: "50%",
                              height: "500px",
                              overflowY: "auto",
                            }}
                          >
                            <Row>
                              {this.state.communicationTransactionErrors &&
                                this.state.communicationTransactionErrors.length >
                                0 ? (
                                <>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{
                                      textAlign: "center",
                                      marginTop: "10px",
                                    }}
                                  >
                                    Errors
                                  </Typography>
                                  <div
                                    style={{
                                      width: "100%",
                                      margin: "auto",

                                      overflowY: "auto",
                                    }}
                                  >
                                    <TableContainer
                                      component={Paper}
                                      style={{
                                        margin: "auto",
                                        width: "100%",
                                      }}
                                    >
                                      <Table aria-label="simple table">
                                        <TableHead
                                          style={{ backgroundColor: "#fafafa" }}
                                        >
                                          <TableRow
                                            style={{ textAlign: "center" }}
                                          >
                                            <TableCell align="center">
                                              Message
                                            </TableCell>
                                            <TableCell align="center">
                                              Expression
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {this.state.communicationTransactionErrors.map(
                                            (ele, index) => {
                                              return (
                                                <TableRow>
                                                  <TableCell
                                                    align="center"
                                                    style={{
                                                      textTransform:
                                                        "capitalize",
                                                    }}
                                                  >
                                                    {ele.message}
                                                  </TableCell>
                                                  <TableCell
                                                    align="center"
                                                    style={{
                                                      textTransform:
                                                        "capitalize",
                                                    }}
                                                  >
                                                    {ele.expression}
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            }
                                          )}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </div>
                                </>
                              ) : null}
                            </Row>
                          </Box>
                        </Modal>
                      </>
                    ) : null}
                    <hr />
                    <Row>
                      <Col xs={3}>
                        <div>
                          <label style={{ fontWeight: "bold" }}>
                            Medical File:{" "}
                          </label>
                          {visitNeedApproval.medicalfilenumber}
                        </div>
                        <div style={{ textTransform: "capitalize" }}>
                          <label style={{ fontWeight: "bold" }}>Gender: </label>
                          {visitNeedApproval.gender}
                        </div>
                        <div style={{ textTransform: "capitalize" }}>
                          <label style={{ fontWeight: "bold" }}>
                            Claim Type:{" "}
                          </label>{" "}
                          {editClaim ? (
                            <>
                              <FormControl style={{ width: "70%" }}>
                                <InputLabel
                                  id="Claim Type"
                                  style={{ fontSize: "small" }}
                                >
                                  Claim Type
                                </InputLabel>
                                <Select
                                  required
                                  labelId="Claim Type"
                                  name="claimType"
                                  label="Claim Type"
                                  onChange={this.HandleInputTextChange}
                                  style={{ height: "45px" }}
                                  value={this.state.calimDefaultValue}
                                >
                                  <MenuItem
                                    value="institutional"
                                    style={{ fontSize: "small" }}
                                  >
                                    Institutional
                                  </MenuItem>
                                  <MenuItem
                                    value="oral"
                                    style={{ fontSize: "small" }}
                                  >
                                    Oral
                                  </MenuItem>
                                  <MenuItem
                                    value="pharmacy"
                                    style={{ fontSize: "small" }}
                                  >
                                    Pharmacy
                                  </MenuItem>
                                  <MenuItem
                                    value="professional"
                                    style={{ fontSize: "small" }}
                                  >
                                    Professional
                                  </MenuItem>
                                  <MenuItem
                                    value="vision"
                                    style={{ fontSize: "small" }}
                                  >
                                    Vision
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </>
                          ) : (
                            visitNeedApproval.claimtype
                          )}
                        </div>
                      </Col>

                      <Col xs={3}>
                        <div style={{ textTransform: "capitalize" }}>
                          <label style={{ fontWeight: "bold" }}>
                            Patient Name:{" "}
                          </label>
                          {visitNeedApproval.firstname}{" "}
                          {visitNeedApproval.lastname}
                        </div>
                        <div style={{ textTransform: "capitalize" }}>
                          <label style={{ fontWeight: "bold" }}>
                            Nationality:{" "}
                          </label>
                          {visitNeedApproval.nationality}
                        </div>
                        <div>
                          <label style={{ fontWeight: "bold" }}>
                            Visit Sart Date:{" "}
                          </label>
                          {visitNeedApproval.visitstartdate}
                        </div>
                      </Col>

                      <Col xs={3}>
                        <div>
                          <label style={{ fontWeight: "bold" }}>
                            Birthdate:{" "}
                          </label>
                          {visitNeedApproval.birthdate}
                        </div>
                        <div style={{ textTransform: "capitalize" }}>
                          <label style={{ fontWeight: "bold" }}>
                            Visit Type:{" "}
                          </label>
                          {visitNeedApproval.visittype}
                        </div>

                        <div>
                          <label style={{ fontWeight: "bold" }}>
                            Visit End Date:{" "}
                          </label>
                          {visitNeedApproval.visitenddate}
                        </div>
                      </Col>

                      <Col xs={3}>
                        <div>
                          <label style={{ fontWeight: "bold" }}>Age: </label>{" "}
                          {visitNeedApproval.age}
                        </div>
                        <div>
                          <label style={{ fontWeight: "bold" }}>Doctor: </label>{" "}
                          {visitNeedApproval.doctorName}
                        </div>
                      </Col>
                    </Row>
                    <hr />
                    <Row>
                      <Col xs={4}>
                        {visitNeedApproval.tpa ? (
                          <div style={{ textTransform: "capitalize" }}>
                            <label style={{ fontWeight: "bold" }}>TPA:</label>
                            {allTPA[visitNeedApproval.tpa]}
                          </div>
                        ) : null}
                        <div style={{ textTransform: "capitalize" }}>
                          <label style={{ fontWeight: "bold" }}>
                            Insurance Company:
                          </label>
                          {visitNeedApproval.insurancecompany}
                        </div>

                        {visitNeedApproval &&
                          visitNeedApproval.eligibilityresponseidentifier ? (
                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Eligibility Identifier:
                            </label>
                            {visitNeedApproval.eligibilityresponseidentifier}
                          </div>
                        ) : null}
                      </Col>

                      <Col xs={4}>
                        {visitNeedApproval.authorizationstatus ? (
                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Pre-Auth Status:{" "}
                            </label>
                            {visitNeedApproval.authorizationstatus === "1"
                              ? "Pending"
                              : visitNeedApproval.authorizationstatus === "2"
                                ? "Faild"
                                : visitNeedApproval.authorizationstatus === "3"
                                  ? "Complete"
                                  : visitNeedApproval.authorizationstatus === "4"
                                    ? "Queued"
                                    : visitNeedApproval.authorizationstatus ===
                                      "cancelled"
                                      ? "Cancelled"
                                      : null}
                          </div>
                        ) : null}

                        {visitNeedApproval &&
                          visitNeedApproval.authorizationRequestIdentifier ? (
                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Pre-Auth Request Identifier:{" "}
                            </label>
                            {visitNeedApproval.authorizationRequestIdentifier}
                          </div>
                        ) : null}
                      </Col>

                      <Col xs={4}>
                        {visitNeedApproval &&
                          visitNeedApproval.adjucationoutcome ? (
                          <div style={{ textTransform: "capitalize" }}>
                            <label style={{ fontWeight: "bold" }}>
                              Pre-Auth Adjudication Outcome:{" "}
                            </label>
                            {visitNeedApproval.adjucationoutcome}
                          </div>
                        ) : null}

                        {visitNeedApproval &&
                          visitNeedApproval.authorizationResponseIdentifier ? (
                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Pre-Auth Response Identifier:{" "}
                            </label>
                            {visitNeedApproval.authorizationResponseIdentifier}
                          </div>
                        ) : null}

                        {visitNeedApproval && visitNeedApproval.preAuthRef ? (
                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Pre-Auth Reference(Approval Number):{" "}
                            </label>
                            {visitNeedApproval.preAuthRef}
                          </div>
                        ) : null}
                      </Col>
                    </Row>

                    <hr />

                    <Row>
                      <Col xs={6}>
                        {(allDiagnosisRows && allDiagnosisRows.length > 0) ||
                          addDiagnosis ? (
                          <div
                            style={{
                              margin: "auto",
                              width: "80%",
                            }}
                          >
                            <TableContainer
                              component={Paper}
                              style={{ marginTop: "10px" }}
                            >
                              <Table aria-label="simple table">
                                <TableHead
                                  style={{ backgroundColor: "#fafafa" }}
                                >
                                  <TableRow>
                                    <TableCell
                                      align="center"
                                      colSpan={
                                        editClaim &&
                                          this.state.calimDefaultValue ===
                                          "institutional"
                                          ? 6
                                          : editClaim &&
                                            this.state.calimDefaultValue !==
                                            "institutional"
                                            ? 5
                                            : 4
                                      }
                                    >
                                      Diagnosis
                                    </TableCell>
                                  </TableRow>
                                  {allDiagnosisRows &&
                                    allDiagnosisRows.length > 0 ? (
                                    <>
                                      <TableRow style={{ textAlign: "center" }}>
                                        {editClaim &&
                                          this.state.calimDefaultValue ===
                                          "institutional" ? (
                                          <>
                                            <TableCell align="center">
                                              On Admission
                                            </TableCell>
                                          </>
                                        ) : null}
                                        <TableCell align="center">ID</TableCell>
                                        <TableCell align="center">
                                          Type
                                        </TableCell>
                                        <TableCell align="center">
                                          Code
                                        </TableCell>
                                        <TableCell align="center">
                                          Description
                                        </TableCell>
                                        {editClaim ? (
                                          <TableCell align="center">
                                            Action
                                          </TableCell>
                                        ) : null}
                                      </TableRow>
                                    </>
                                  ) : null}
                                </TableHead>

                                <TableBody>{allDiagnosisRows}</TableBody>
                                {this.state.addDiagnosis ? (
                                  <>
                                    <TableRow
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableCell
                                        align="center"
                                        colSpan={
                                          this.state.calimDefaultValue ===
                                            "institutional"
                                            ? 3
                                            : 2
                                        }
                                      >
                                        Type
                                      </TableCell>
                                      <TableCell align="center" colSpan={2}>
                                        Code
                                      </TableCell>
                                      <TableCell align="center">Add</TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        colSpan={
                                          this.state.calimDefaultValue ===
                                            "institutional"
                                            ? 3
                                            : 2
                                        }
                                        style={{ width: "45%" }}
                                      >
                                        <FormControl sx={{ width: "100%" }}>
                                          <InputLabel
                                            id="typeLabel"
                                            style={{ fontSize: "small" }}
                                          >
                                            Type
                                          </InputLabel>
                                          <Select
                                            style={{ height: "40px" }}
                                            required
                                            labelId="typeLabel"
                                            name="type"
                                            label="Type"
                                            onChange={
                                              this.HandleDiagnosisChange
                                            }
                                          >
                                            <MenuItem
                                              value="principal"
                                              style={{ fontSize: "small" }}
                                            >
                                              Principal
                                            </MenuItem>
                                            <MenuItem
                                              value="secondary"
                                              style={{ fontSize: "small" }}
                                            >
                                              Secondary
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        colSpan={2}
                                        style={{ width: "45%" }}
                                      >
                                        <FormControl>
                                          <Autocomplete
                                            suggestions={
                                              this.state.allDiagnosisOptions
                                                ? this.state.allDiagnosisOptions
                                                : []
                                            }
                                            onChangeSetCode={
                                              this.handleDiagnosisSelect
                                            }
                                            flag={this.state.autoCompleteValue}
                                          />
                                        </FormControl>
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{ width: "10%" }}
                                      >
                                        <a
                                          onClick={(e) => {
                                            this.handleSubmitAddNewDiagnosis(e);
                                          }}
                                        >
                                          <AddCircleIcon
                                            style={{ cursor: "pointer" }}
                                          />
                                        </a>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                ) : null}
                                {editClaim ? (
                                  <TableRow>
                                    <TableCell align="center" colSpan={5}>
                                      <Button
                                        style={{
                                          width: "10%",
                                          backgroundColor: "rgb(97 110 120",
                                          border: "1px ridge gray",
                                          color: "white",
                                          fontSize: "smaller",
                                        }}
                                        onClick={(e) => {
                                          this.setState({
                                            addDiagnosis: "true",
                                          });
                                        }}
                                      >
                                        <AddCircleIcon />
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                ) : null}
                              </Table>
                            </TableContainer>
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={6}>
                        {(supportingInformationTable &&
                          supportingInformationTable.length > 0) ||
                          this.state.addVital ? (
                          <>
                            <div style={{ margin: "auto" }}>
                              <TableContainer
                                component={Paper}
                                style={{ marginTop: "10px", width: "80%" }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead
                                    style={{ backgroundColor: "#fafafa" }}
                                  >
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        colSpan={editClaim ? 4 : 3}
                                      >
                                        Supporting Information
                                      </TableCell>
                                    </TableRow>
                                    {supportingInformationTable &&
                                      supportingInformationTable.length > 0 ? (
                                      <>
                                        <TableRow
                                          style={{ textAlign: "center" }}
                                        >
                                          <TableCell align="center">
                                            ID
                                          </TableCell>
                                          <TableCell align="center">
                                            Information
                                          </TableCell>
                                          <TableCell align="center">
                                            Value
                                          </TableCell>
                                          {editClaim ? (
                                            <TableCell align="center">
                                              Action
                                            </TableCell>
                                          ) : null}
                                        </TableRow>
                                      </>
                                    ) : null}
                                  </TableHead>

                                  <TableBody>
                                    {supportingInformationTable}
                                  </TableBody>
                                  {this.state.addVital ? (
                                    <>
                                      <TableRow
                                        style={{ backgroundColor: "#fafafa" }}
                                      >
                                        <TableCell align="center" colSpan={3}>
                                          Vital Sign
                                        </TableCell>
                                        <TableCell align="center">
                                          Add
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          align="center"
                                          colSpan={3}
                                          style={{ width: "45%" }}
                                        >
                                          <div style={{ textAlign: "center" }}>
                                            <FormControl
                                              style={{ width: "70%" }}
                                              sx={{ mb: 3 }}
                                            >
                                              <InputLabel
                                                id="category"
                                                style={{ fontSize: "small" }}
                                              >
                                                Vital Sign
                                              </InputLabel>
                                              <Select
                                                labelId="supportingInformation"
                                                name="category"
                                                label="supportingInformation"
                                                onChange={
                                                  this.HandleVitalSignChange
                                                }
                                                value={this.state.vitalSelect}
                                                style={{ height: "45px" }}
                                              >
                                                <MenuItem
                                                  value="vital-sign-diastolic"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Diastolic
                                                </MenuItem>
                                                <MenuItem
                                                  value="vital-sign-systolic"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Systolic
                                                </MenuItem>
                                                <MenuItem
                                                  value="vital-sign-height"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Height
                                                </MenuItem>
                                                <MenuItem
                                                  value="vital-sign-weight"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Weight
                                                </MenuItem>

                                                <MenuItem
                                                  value="temperature"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Temperature
                                                </MenuItem>

                                                <MenuItem
                                                  value="pulse"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Pulse
                                                </MenuItem>

                                                <MenuItem
                                                  value="respiratory-rate"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Respiratory Rate
                                                </MenuItem>

                                                <MenuItem
                                                  value="chief-complaint"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Chief Complaint
                                                </MenuItem>
                                                <MenuItem
                                                  value="birth-weight"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Birth weight
                                                </MenuItem>
                                                <MenuItem
                                                  value="attachment"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Attachment
                                                </MenuItem>
                                              </Select>
                                            </FormControl>
                                          </div>
                                          {this.state.chiefComplainSelected ? (
                                            <>
                                              <div
                                                style={{ textAlign: "center" }}
                                              >
                                                <FormControl
                                                  style={{ width: "70%" }}
                                                  sx={{ mb: 3 }}
                                                >
                                                  <TextField
                                                    InputLabelProps={{
                                                      sx: { fontSize: "small" },
                                                    }}
                                                    value={
                                                      this.state.vitalValue
                                                    }
                                                    inputProps={{
                                                      sx: { padding: "11px" },
                                                    }}
                                                    required
                                                    type="text"
                                                    name={
                                                      this.state.selectedName
                                                    }
                                                    label={
                                                      this.state.selectedName
                                                    }
                                                    variant="outlined"
                                                    onChange={
                                                      this
                                                        .HandleSupportingInfoChange
                                                    }
                                                  />
                                                </FormControl>
                                              </div>
                                              <div
                                                style={{ textAlign: "center" }}
                                              >
                                                <Button
                                                  variant="contained"
                                                  style={{
                                                    backgroundColor:
                                                      "rgb(97 110 120",
                                                    width: "100px",
                                                  }}
                                                  onClick={(e) =>
                                                    this.handleConfirm(e)
                                                  }
                                                >
                                                  Add
                                                </Button>
                                              </div>
                                            </>
                                          ) : this.state.attachmentSelected ? (
                                            <>
                                              <input
                                                style={{
                                                  display: "block",
                                                  margin: "auto",
                                                  marginRight: "5px",
                                                }}
                                                type="file"
                                                onChange={this.onFileChange}
                                              />
                                              {this.state.fileMsg ? (
                                                <>
                                                  <div
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      {this.state.fileMsg}
                                                    </span>
                                                  </div>
                                                </>
                                              ) : null}
                                            </>
                                          ) : this.state.vitalSignSelected ? (
                                            <>
                                              <div
                                                style={{ textAlign: "center" }}
                                              >
                                                <FormControl
                                                  style={{ width: "70%" }}
                                                  sx={{ mb: 3 }}
                                                >
                                                  <TextField
                                                    InputLabelProps={{
                                                      sx: { fontSize: "small" },
                                                    }}
                                                    value={
                                                      this.state.vitalValue
                                                    }
                                                    inputProps={{
                                                      sx: { padding: "11px" },
                                                    }}
                                                    required
                                                    type="number"
                                                    name={
                                                      this.state.selectedName
                                                    }
                                                    label={
                                                      this.state.selectedName
                                                    }
                                                    variant="outlined"
                                                    onChange={
                                                      this
                                                        .HandleSupportingInfoChange
                                                    }
                                                  />
                                                </FormControl>
                                              </div>
                                            </>
                                          ) : null}
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ width: "10%" }}
                                        >
                                          <a
                                            style={{
                                              display: "inline-block",
                                              marginBottom: "30px",
                                            }}
                                            onClick={(e) => {
                                              this.handleConfirm(e);
                                            }}
                                          >
                                            <AddCircleIcon
                                              style={{ cursor: "pointer" }}
                                            />
                                          </a>
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  ) : null}
                                  {editClaim ? (
                                    <TableRow>
                                      <TableCell align="center" colSpan={4}>
                                        <Button
                                          style={{
                                            width: "10%",
                                            backgroundColor: "rgb(97 110 120",
                                            border: "1px ridge gray",
                                            color: "white",
                                            fontSize: "smaller",
                                          }}
                                          onClick={(e) => {
                                            this.setState({
                                              addVital: "true",
                                            });
                                          }}
                                        >
                                          <AddCircleIcon />
                                        </Button>
                                      </TableCell>
                                    </TableRow>
                                  ) : null}
                                </Table>
                              </TableContainer>
                            </div>
                          </>
                        ) : null}
                      </Col>
                    </Row>
                    <hr />
                    {(allproceduresRows && allproceduresRows.length > 0) ||
                      this.state.addProcedure ? (
                      <>
                        <div style={{ width: "100%", margin: "auto" }}>
                          <TableContainer
                            component={Paper}
                            style={{ marginTop: "10px", width: "100%" }}
                          >
                            <Table aria-label="simple table">
                              {allproceduresRows &&
                                allproceduresRows.length > 0 ? (
                                <TableHead
                                  style={{ backgroundColor: "#fafafa" }}
                                >
                                  <TableRow></TableRow>
                                  <TableRow style={{ textAlign: "center" }}>
                                    <TableCell align="center">Type</TableCell>
                                    <TableCell align="center">Code</TableCell>
                                    <TableCell align="center">
                                      Description
                                    </TableCell>
                                    <TableCell align="center">
                                      Quantity
                                    </TableCell>

                                    {this.state.showToothNumber ? (
                                      <TableCell align="center">
                                        Tooth Number
                                      </TableCell>
                                    ) : null}
                                    <TableCell align="center">
                                      Unit Price
                                    </TableCell>
                                    <TableCell align="center">
                                      Discount(%)
                                    </TableCell>
                                    <TableCell align="center">Tax</TableCell>
                                    <TableCell align="center">
                                      Deduction(%)
                                    </TableCell>
                                    <TableCell align="center">
                                      Patient Share
                                    </TableCell>
                                    <TableCell align="center">Net</TableCell>
                                    <TableCell align="center">Tooth</TableCell>
                                    <TableCell align="center">
                                      Related Diagnosis
                                    </TableCell>

                                    <TableCell align="center">
                                      Related Information Sequence
                                    </TableCell>

                                    {(authorizationstatus &&
                                      authorizationstatus == "3") ||
                                      (authorizationstatus == "cancelled" &&
                                        errorsRow.length == 0 &&
                                        !this.state.queuedInfoFlag) ? (
                                      <TableCell align="center">
                                        Pre-Approval Response
                                      </TableCell>
                                    ) : null}
                                    {editClaim ? (
                                      <TableCell align="center">
                                        Action
                                      </TableCell>
                                    ) : null}
                                  </TableRow>
                                </TableHead>
                              ) : null}

                              <TableBody>{allproceduresRows}</TableBody>
                              <TableRow>
                                <TableCell
                                  colSpan={
                                    visitNeedApproval.adjucationoutcome
                                      ? 15
                                      : 12
                                  }
                                >
                                  Pre-Authorization Total Net :{" "}
                                  {parseFloat(totalSum).toFixed(2)}
                                  {" SAR"}
                                </TableCell>
                              </TableRow>
                              {this.state.addProcedure ? (
                                <TableRow>
                                  <TableCell
                                    colSpan={
                                      visitNeedApproval.adjucationoutcome
                                        ? 15
                                        : 12
                                    }
                                  >
                                    <Accordion
                                      defaultActiveKey="0"
                                      style={{
                                        margin: "auto",
                                        paddingBottom: "20px",
                                        width: "100%",
                                      }}
                                    >
                                      <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                          <span style={{ color: "grey" }}>
                                            Procedure Form
                                          </span>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                          <div style={{ textAlign: "center" }}>
                                            <Row>
                                              <Col>
                                                <FormControl
                                                  style={{
                                                    width: "100%",
                                                    margin: "10px auto",
                                                  }}
                                                  sx={{ mb: 3 }}
                                                >
                                                  <InputLabel
                                                    id="service type"
                                                    style={{
                                                      fontSize: "small",
                                                    }}
                                                  >
                                                    Service Type
                                                  </InputLabel>
                                                  <Select
                                                    required
                                                    fullWidth
                                                    style={{ height: "45px" }}
                                                    labelId="service type"
                                                    name="type"
                                                    label="Service Type"
                                                    value={
                                                      procedure.type
                                                        ? procedure.type
                                                        : ""
                                                    }
                                                    onChange={
                                                      this.HandleProcedureChange
                                                    }
                                                  >
                                                    <MenuItem
                                                      value="consultation"
                                                      style={{
                                                        fontSize: "small",
                                                      }}
                                                    >
                                                      Consultation
                                                    </MenuItem>
                                                    <MenuItem
                                                      value="dental"
                                                      style={{
                                                        fontSize: "small",
                                                      }}
                                                    >
                                                      Dental
                                                    </MenuItem>{" "}
                                                    <MenuItem
                                                      value="laboratory"
                                                      style={{
                                                        fontSize: "small",
                                                      }}
                                                    >
                                                      Laboratory
                                                    </MenuItem>{" "}
                                                    <MenuItem
                                                      value="medication"
                                                      style={{
                                                        fontSize: "small",
                                                      }}
                                                    >
                                                      Medication
                                                    </MenuItem>{" "}
                                                    <MenuItem
                                                      value="procedure"
                                                      style={{
                                                        fontSize: "small",
                                                      }}
                                                    >
                                                      Procedure
                                                    </MenuItem>
                                                    <MenuItem
                                                      value="radiology"
                                                      style={{
                                                        fontSize: "small",
                                                      }}
                                                    >
                                                      Radiology
                                                    </MenuItem>
                                                  </Select>
                                                </FormControl>
                                                <FormControl
                                                  sx={{ mb: 3 }}
                                                  style={{
                                                    width: "100%",
                                                    margin: " 10px auto",
                                                  }}
                                                >
                                                  <TextField
                                                    InputLabelProps={{
                                                      sx: { fontSize: "small" },
                                                      shrink: this.state
                                                        .autoValue
                                                        ? true
                                                        : false,
                                                    }}
                                                    value={
                                                      this.state.autoValue
                                                        ? procedure.discount
                                                        : ""
                                                    }
                                                    inputProps={{
                                                      sx: { padding: "11px" },
                                                      min: 0,
                                                      readOnly: true,
                                                    }}
                                                    required
                                                    type="number"
                                                    name="discount"
                                                    label="Discount"
                                                    variant="outlined"
                                                    onChange={
                                                      this.HandleProcedureChange
                                                    }
                                                  />
                                                </FormControl>

                                                {this.state
                                                  .pharmacistSelection ? (
                                                  <>
                                                    <FormControl
                                                      fullWidth
                                                      sx={{ mb: 3 }}
                                                      style={{
                                                        width: "100%",
                                                        margin: "10px auto",
                                                      }}
                                                    >
                                                      <InputLabel
                                                        id="pharmacistSelectionReason"
                                                        style={{
                                                          fontSize: "small",
                                                        }}
                                                      >
                                                        Pharmacist Selection
                                                        Reason
                                                      </InputLabel>
                                                      <Select
                                                        required
                                                        labelId="pharmacistSelectionReason"
                                                        name="pharmacistSelectionReason"
                                                        label="Pharmacist Selection Reason"
                                                        style={{
                                                          height: "45px",
                                                        }}
                                                        value={
                                                          procedure[
                                                            "pharmacistSelectionReason"
                                                          ]
                                                            ? procedure[
                                                            "pharmacistSelectionReason"
                                                            ]
                                                            : ""
                                                        }
                                                        onChange={
                                                          this
                                                            .HandleProcedureChange
                                                        }
                                                      >
                                                        <MenuItem
                                                          value="Generic"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          Generic
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="patient-request"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          Patient Request
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="innovative-noGeneric"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          Innovative noGeneric
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="physician-approval"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          Physician-request with
                                                          payer approval
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="physician-no-approval"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          Physician-request
                                                          without payer approval
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="drug-pharmacyUnavailable"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          Drug-pharmacyUnavailable
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="drug-nationallyUnavailable"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          Drug-nationallyUnavailable
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="pharmacist-policy-eligibility"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          Pharmacist selection
                                                          based on policy
                                                          eligibility
                                                        </MenuItem>

                                                        <MenuItem
                                                          value="Irreplaceable"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          SFDA Irreplaceable
                                                          drugs
                                                        </MenuItem>
                                                      </Select>
                                                    </FormControl>
                                                  </>
                                                ) : null}
                                                {this.state.showToothNumber ? (
                                                  <>
                                                    <FormControl
                                                      fullWidth
                                                      sx={{ mb: 3 }}
                                                      style={{
                                                        width: "100%",
                                                        margin: "10px auto",
                                                      }}
                                                    >
                                                      <InputLabel
                                                        id="toothnumber"
                                                        style={{
                                                          fontSize: "small",
                                                        }}
                                                      >
                                                        Tooth Number
                                                      </InputLabel>
                                                      <Select
                                                        required
                                                        labelId="toothnumber"
                                                        name="toothNumber"
                                                        label="Tooth Number"
                                                        style={{
                                                          height: "45px",
                                                        }}
                                                        value={
                                                          procedure[
                                                            "toothNumber"
                                                          ]
                                                            ? procedure[
                                                            "toothNumber"
                                                            ] +
                                                            "-" +
                                                            procedure[
                                                            "toothDescription"
                                                            ]
                                                            : ""
                                                        }
                                                        onChange={
                                                          this
                                                            .HandleProcedureChange
                                                        }
                                                      >
                                                        <MenuItem
                                                          value="11-UPPER RIGHT; PERMANENT TEETH # 1"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          11-UPPER RIGHT;
                                                          PERMANENT TEETH # 1
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="12-UPPER RIGHT; PERMANENT TEETH # 2"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          12-UPPER RIGHT;
                                                          PERMANENT TEETH # 2
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="13-UPPER RIGHT; PERMANENT TEETH # 3"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          13-UPPER RIGHT;
                                                          PERMANENT TEETH # 3
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="14-UPPER RIGHT; PERMANENT TEETH # 4"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          14-UPPER RIGHT;
                                                          PERMANENT TEETH # 4
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="15-UPPER RIGHT; PERMANENT TEETH # 5"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          15-UPPER RIGHT;
                                                          PERMANENT TEETH # 5
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="16-UPPER RIGHT; PERMANENT TEETH # 6"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          16-UPPER RIGHT;
                                                          PERMANENT TEETH # 6
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="17-UPPER RIGHT; PERMANENT TEETH # 7"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          17-UPPER RIGHT;
                                                          PERMANENT TEETH # 7
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="18-UPPER RIGHT; PERMANENT TEETH # 8"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          18-UPPER RIGHT;
                                                          PERMANENT TEETH # 8
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="21-UPPER LEFT; PERMANENT TEETH # 1"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          21-UPPER LEFT;
                                                          PERMANENT TEETH # 1
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="22-UPPER LEFT; PERMANENT TEETH # 2"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          22-UPPER LEFT;
                                                          PERMANENT TEETH # 2
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="23-UPPER LEFT; PERMANENT TEETH # 3"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          23-UPPER LEFT;
                                                          PERMANENT TEETH # 3
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="24-UPPER LEFT; PERMANENT TEETH # 4"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          24-UPPER LEFT;
                                                          PERMANENT TEETH # 4
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="25-UPPER LEFT; PERMANENT TEETH # 5"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          25-UPPER LEFT;
                                                          PERMANENT TEETH # 5
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="26-UPPER LEFT; PERMANENT TEETH # 6"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          26-UPPER LEFT;
                                                          PERMANENT TEETH # 6
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="27-UPPER LEFT; PERMANENT TEETH # 7"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          27-UPPER LEFT;
                                                          PERMANENT TEETH # 7
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="28-UPPER LEFT; PERMANENT TEETH # 8"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          28-UPPER LEFT;
                                                          PERMANENT TEETH # 8
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="31-LOWER LEFT; PERMANENT TEETH # 1"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          31-LOWER LEFT;
                                                          PERMANENT TEETH # 1
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="32-LOWER LEFT; PERMANENT TEETH # 2"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          32-LOWER LEFT;
                                                          PERMANENT TEETH # 2
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="33-LOWER LEFT; PERMANENT TEETH # 3"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          33-LOWER LEFT;
                                                          PERMANENT TEETH # 3
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="34-LOWER LEFT; PERMANENT TEETH # 4"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          34-LOWER LEFT;
                                                          PERMANENT TEETH # 4
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="35-LOWER LEFT; PERMANENT TEETH # 5"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          35-LOWER LEFT;
                                                          PERMANENT TEETH # 5
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="36-LOWER LEFT; PERMANENT TEETH # 6"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          36-LOWER LEFT;
                                                          PERMANENT TEETH # 6
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="37-LOWER LEFT; PERMANENT TEETH # 7"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          37-LOWER LEFT;
                                                          PERMANENT TEETH # 7
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="38-LOWER LEFT; PERMANENT TEETH # 8"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          38-LOWER LEFT;
                                                          PERMANENT TEETH # 8
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="41-LOWER RIGHT; PERMANENT TEETH # 1"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          41-LOWER RIGHT;
                                                          PERMANENT TEETH # 1
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="42-LOWER RIGHT; PERMANENT TEETH # 2"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          42-LOWER RIGHT;
                                                          PERMANENT TEETH # 2"
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="43-LOWER RIGHT; PERMANENT TEETH # 3"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          43-LOWER RIGHT;
                                                          PERMANENT TEETH # 3
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="44-LOWER RIGHT; PERMANENT TEETH # 4"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          44-LOWER RIGHT;
                                                          PERMANENT TEETH # 4
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="45-LOWER RIGHT; PERMANENT TEETH # 5"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          45-LOWER RIGHT;
                                                          PERMANENT TEETH # 5
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="46-LOWER RIGHT; PERMANENT TEETH # 6"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          46-LOWER RIGHT;
                                                          PERMANENT TEETH # 6
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="47-LOWER RIGHT; PERMANENT TEETH # 7"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          47-LOWER RIGHT;
                                                          PERMANENT TEETH # 7
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="48-LOWER RIGHT; PERMANENT TEETH # 8"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          48-LOWER RIGHT;
                                                          PERMANENT TEETH # 8
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="51-UPPER RIGHT; DECIDUOUS TEETH # 1"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          51-UPPER RIGHT;
                                                          DECIDUOUS TEETH # 1
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="52-UPPER RIGHT; DECIDUOUS TEETH # 2"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          52-UPPER RIGHT;
                                                          DECIDUOUS TEETH # 2
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="53-UPPER RIGHT; DECIDUOUS TEETH # 3"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          53-UPPER RIGHT;
                                                          DECIDUOUS TEETH # 3
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="54-UPPER RIGHT; DECIDUOUS TEETH # 4"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          54-UPPER RIGHT;
                                                          DECIDUOUS TEETH # 4
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="55-UPPER RIGHT; DECIDUOUS TEETH # 5"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          55-UPPER RIGHT;
                                                          DECIDUOUS TEETH # 5
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="61-UPPER LEFT; DECIDUOUS TEETH # 1"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          61-UPPER LEFT;
                                                          DECIDUOUS TEETH # 1
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="62-UPPER LEFT; DECIDUOUS TEETH # 2"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          62-UPPER LEFT;
                                                          DECIDUOUS TEETH # 2
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="63-UPPER LEFT; DECIDUOUS TEETH # 3"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          63-UPPER LEFT;
                                                          DECIDUOUS TEETH # 3
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="64-UPPER LEFT; DECIDUOUS TEETH # 4"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          64-UPPER LEFT;
                                                          DECIDUOUS TEETH # 4
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="65-UPPER LEFT; DECIDUOUS TEETH # 5"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          65-UPPER LEFT;
                                                          DECIDUOUS TEETH # 5
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="71-LOWER LEFT; DECIDUOUS TEETH # 1"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          71-LOWER LEFT;
                                                          DECIDUOUS TEETH # 1
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="72-LOWER LEFT; DECIDUOUS TEETH # 2"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          72-LOWER LEFT;
                                                          DECIDUOUS TEETH # 2
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="73-LOWER LEFT; DECIDUOUS TEETH # 3"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          73-LOWER LEFT;
                                                          DECIDUOUS TEETH # 3
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="74-LOWER LEFT; DECIDUOUS TEETH # 4"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          74-LOWER LEFT;
                                                          DECIDUOUS TEETH # 4
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="75-LOWER LEFT; DECIDUOUS TEETH # 5"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          75-LOWER LEFT;
                                                          DECIDUOUS TEETH # 5
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="81-LOWER RIGHT; DECIDUOUS TEETH # 1"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          81-LOWER RIGHT;
                                                          DECIDUOUS TEETH # 1
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="82-LOWER RIGHT; DECIDUOUS TEETH # 2"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          82-LOWER RIGHT;
                                                          DECIDUOUS TEETH # 2
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="83-LOWER RIGHT; DECIDUOUS TEETH # 3"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          83-LOWER RIGHT;
                                                          DECIDUOUS TEETH # 3
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="84-LOWER RIGHT; DECIDUOUS TEETH # 4"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          84-LOWER RIGHT;
                                                          DECIDUOUS TEETH # 4
                                                        </MenuItem>
                                                        <MenuItem
                                                          value="85-LOWER RIGHT; DECIDUOUS TEETH # 5"
                                                          style={{
                                                            fontSize: "small",
                                                          }}
                                                        >
                                                          85-LOWER RIGHT;
                                                          DECIDUOUS TEETH # 5
                                                        </MenuItem>
                                                      </Select>
                                                    </FormControl>
                                                  </>
                                                ) : null}
                                              </Col>
                                              <Col>
                                                <FormControl
                                                  sx={{ mb: 3 }}
                                                  style={{
                                                    width: "100%",
                                                    margin: "10px auto",
                                                  }}
                                                >
                                                  <AutoComplete
                                                    sx={{
                                                      "& .MuiInputBase-input": {
                                                        height: "12px",
                                                      },
                                                      ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root":
                                                      {
                                                        fontSize: "small",
                                                      },
                                                    }}
                                                    options={
                                                      this.state.autoOptions
                                                        ? this.state.autoOptions
                                                        : []
                                                    }
                                                    value={this.state.autoValue}
                                                    onChange={
                                                      this.handleCodeChange
                                                    }
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        label="Choose a code"
                                                      />
                                                    )}
                                                  />
                                                </FormControl>
                                                <FormControl
                                                  sx={{ mb: 3 }}
                                                  style={{
                                                    width: "100%",
                                                    margin: " 10px auto",
                                                  }}
                                                >
                                                  <TextField
                                                    InputLabelProps={{
                                                      sx: { fontSize: "small" },
                                                      shrink: this.state
                                                        .autoValue
                                                        ? true
                                                        : false,
                                                    }}
                                                    value={
                                                      this.state.autoValue
                                                        ? procedure.tax
                                                        : ""
                                                    }
                                                    inputProps={{
                                                      sx: { padding: "11px" },
                                                      readOnly: true,
                                                    }}
                                                    required
                                                    type="number"
                                                    name="tax_calculated"
                                                    label="Tax"
                                                    variant="outlined"
                                                  /*   onChange={
                                                  this.HandleProcedureChange
                                                } */
                                                  />
                                                </FormControl>

                                                <FormControl
                                                  sx={{ mb: 3 }}
                                                  style={{
                                                    width: "100%",
                                                    margin: "10px auto",
                                                  }}
                                                >
                                                  <TextField
                                                    InputLabelProps={{
                                                      sx: { fontSize: "small" },
                                                    }}
                                                    value={procedure.deduction}
                                                    inputProps={{
                                                      sx: { padding: "11px" },
                                                      min: 0,
                                                    }}
                                                    required
                                                    type="number"
                                                    name="deduction"
                                                    label="Deduction(%)"
                                                    variant="outlined"
                                                    onChange={
                                                      this.HandleProcedureChange
                                                    }
                                                  />
                                                </FormControl>
                                                {this.state.serviceValue ===
                                                  "medication" ? (
                                                  <>
                                                    <FormControl
                                                      sx={{ mb: 3 }}
                                                      style={{
                                                        width: "100%",
                                                        margin: " 10px auto",
                                                      }}
                                                    >
                                                      <TextField
                                                        InputLabelProps={{
                                                          sx: {
                                                            fontSize: "small",
                                                          },
                                                        }}
                                                        inputProps={{
                                                          sx: {
                                                            padding: "11px",
                                                          },
                                                          min: 0,
                                                        }}
                                                        required
                                                        type="number"
                                                        name="days-supply"
                                                        label="Days Supply "
                                                        variant="outlined"
                                                        onChange={
                                                          this
                                                            .HandleSupportingInfoChange
                                                        }
                                                      />
                                                    </FormControl>
                                                  </>
                                                ) : null}
                                              </Col>
                                              <Col>
                                                <FormControl
                                                  sx={{ mb: 3 }}
                                                  style={{
                                                    width: "100%",
                                                    margin: " 10px auto",
                                                  }}
                                                >
                                                  <TextField
                                                    InputLabelProps={{
                                                      sx: { fontSize: "small" },
                                                    }}
                                                    value={
                                                      /*  this.state
                                                        .procedureQuantity */ procedure.quantity
                                                    }
                                                    inputProps={{
                                                      sx: { padding: "11px" },
                                                      min: 0,
                                                    }}
                                                    required
                                                    type="number"
                                                    name="quantity"
                                                    label="Quantity"
                                                    variant="outlined"
                                                    onChange={
                                                      this.HandleProcedureChange
                                                    }
                                                  />
                                                </FormControl>
                                                <FormControl
                                                  sx={{ mb: 3 }}
                                                  style={{
                                                    width: "100%",
                                                    margin: " 10px auto",
                                                  }}
                                                >
                                                  <TextField
                                                    InputLabelProps={{
                                                      sx: { fontSize: "small" },
                                                      shrink: this.state
                                                        .autoValue
                                                        ? true
                                                        : false,
                                                    }}
                                                    value={
                                                      this.state.autoValue
                                                        ? parseFloat(
                                                          procedure.net
                                                        ).toFixed(2)
                                                        : ""
                                                    }
                                                    inputProps={{
                                                      sx: { padding: "11px" },
                                                      readOnly: true,
                                                    }}
                                                    required
                                                    type="number"
                                                    name="net"
                                                    label="Net"
                                                    variant="outlined"
                                                  />
                                                </FormControl>

                                                <FormControl
                                                  sx={{ mb: 3 }}
                                                  style={{
                                                    width: "100%",
                                                    margin: " 10px auto",
                                                  }}
                                                >
                                                  <TextField
                                                    InputLabelProps={{
                                                      sx: { fontSize: "small" },
                                                    }}
                                                    value={
                                                      procedure.patientshare
                                                    }
                                                    inputProps={{
                                                      sx: { padding: "11px" },
                                                      min: 0,
                                                    }}
                                                    required
                                                    type="number"
                                                    name="patientshare_total"
                                                    label="Patientshare"
                                                    variant="outlined"
                                                  /*    onChange={
                                                  this.HandleProcedureChange
                                                } */
                                                  />
                                                </FormControl>
                                              </Col>
                                              <Col>
                                                <FormControl
                                                  sx={{ mb: 3 }}
                                                  style={{
                                                    width: "100%",
                                                    margin: " 10px auto",
                                                  }}
                                                >
                                                  <TextField
                                                    InputLabelProps={{
                                                      sx: { fontSize: "small" },
                                                      shrink: this.state
                                                        .autoValue
                                                        ? true
                                                        : false,
                                                    }}
                                                    value={
                                                      this.state.autoValue
                                                        ? procedure.price
                                                        : ""
                                                    }
                                                    inputProps={{
                                                      sx: { padding: "11px" },
                                                      min: 0,
                                                      readOnly: true,
                                                    }}
                                                    required
                                                    type="number"
                                                    name="price"
                                                    label="Price"
                                                    variant="outlined"
                                                  /* 
                                              0 */
                                                  />
                                                </FormControl>
                                                {this.state
                                                  .allDiagnosisSelect &&
                                                  this.state.allDiagnosisSelect
                                                    .length > 0 ? (
                                                  <div
                                                    style={{
                                                      width: "100%",
                                                      margin: "10px auto",
                                                    }}
                                                  >
                                                    <Multiselect
                                                      key={this.state.diagKey}
                                                      placeholder="Diagnosis"
                                                      options={
                                                        this.state
                                                          .allDiagnosisSelect
                                                      }
                                                      // selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                                                      onSelect={
                                                        this.onSelectDiagnosis
                                                      }
                                                      onRemove={
                                                        this.onRemoveDiagnosis
                                                      }
                                                      displayValue="view"
                                                    />
                                                  </div>
                                                ) : null}
                                                {this.state
                                                  .vitalSignSelectArray &&
                                                  this.state.vitalSignSelectArray
                                                    .length > 0 ? (
                                                  <div
                                                    style={{
                                                      width: "100% ",
                                                      margin: "10px auto",
                                                    }}
                                                  >
                                                    <Multiselect
                                                      key={this.state.key}
                                                      placeholder="Supporting Informatiom"
                                                      options={
                                                        this.state
                                                          .vitalSignSelectArray
                                                      }
                                                      onSelect={
                                                        this.onSelectCategory
                                                      }
                                                      onRemove={
                                                        this.onRemoveCategory
                                                      }
                                                      displayValue="display"
                                                    />
                                                  </div>
                                                ) : null}
                                              </Col>
                                            </Row>
                                          </div>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>

                                    <div style={{ textAlign: "center" }}>
                                      <Button
                                        variant="contained"
                                        style={{
                                          marginTop: "30px",
                                          backgroundColor: "rgb(97 110 120",
                                          width: "100px",
                                        }}
                                        onClick={(e) =>
                                          this.handleSubmitAddNewProcedure(e)
                                        }
                                      >
                                        Add
                                      </Button>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ) : null}
                              {editClaim ? (
                                <TableRow>
                                  <TableCell align="center">
                                    <Button
                                      style={{
                                        width: "10%",
                                        backgroundColor: "rgb(97 110 120",
                                        border: "1px ridge gray",
                                        color: "white",
                                        fontSize: "smaller",
                                      }}
                                      onClick={(e) => {
                                        this.handleOpenProcedure();
                                      }}
                                    >
                                      <AddCircleIcon />
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ) : null}
                            </Table>
                          </TableContainer>
                        </div>
                      </>
                    ) : null}
                    {(totalRows && totalRows.length > 0) ||
                      (authorizationstatus == "cancelled" &&
                        errorsRow.length == 0 &&
                        !this.state.queuedInfoFlag) ? (
                      <div style={{ width: "40%", margin: "10px auto" }}>
                        <h4 style={{ textAlign: "center" }}>
                        Total Adjudication
                        </h4>
                        <TableContainer
                          component={Paper}
                        /*  style={{
                         margin: "10px auto",
                         width: "100%",
                       }} */
                        >
                          <Table aria-label="simple table">
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: "center" }}>
                                <TableCell align="center">Category</TableCell>
                                <TableCell align="center">Amount</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>{totalRows}</TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    ) : null}
                    {(this.state.errorsRow &&
                      this.state.errorsRow.length > 0) ||
                      (authorizationstatus == "cancelled" &&
                        totalRows.length == 0 &&
                        !this.state.queuedInfoFlag) ? (
                      <>
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                          style={{ textAlign: "center", marginTop: "10px" }}
                        >
                          Errors
                        </Typography>
                        <div
                          style={{
                            width: "100%",
                            margin: "auto",
                            paddingBottom: "20px",
                          }}
                        >
                          <TableContainer
                            component={Paper}
                            style={{
                              margin: "auto",
                              marginTop: "30px",
                              width: "100%",
                            }}
                          >
                            <Table aria-label="simple table">
                              <TableHead style={{ backgroundColor: "#fafafa" }}>
                                <TableRow style={{ textAlign: "center" }}>
                                  <TableCell align="center">
                                    Error Code
                                  </TableCell>
                                  <TableCell align="center">
                                    Error Display
                                  </TableCell>
                                  <TableCell align="center">
                                    Error Extention
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>{this.state.errorsRow}</TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </>
                    ) : null}
                    {this.state.checkStatusFlag ? (
                      <>
                        <Stack
                          style={{
                            position: "fixed",
                            top: 10,
                            right: 10,
                            zIndex: 9999,
                            textTransform: "capitalize",
                          }}
                        >
                          <Alert severity="info">
                            {this.state.valueCode
                              ? this.state.valueCode
                              : this.state.statusErrors[0].errorMsg}
                          </Alert>
                        </Stack>
                      </>
                    ) : null}
                    {this.state.cancelError ? (
                      <>
                        <Stack
                          style={{
                            position: "fixed",
                            top: 10,
                            right: 10,
                            zIndex: 9999,
                            textTransform: "capitalize",
                          }}
                        >
                          <Alert severity="info">
                            {this.state.cancelError}
                          </Alert>
                        </Stack>
                      </>
                    ) : null}
                    {this.state.diagCodeErrorMsg ? (
                      <>
                        <Stack
                          style={{
                            position: "fixed",
                            top: 10,
                            right: 10,
                            zIndex: 9999,
                            textTransform: "capitalize",
                          }}
                        >
                          <Alert severity="info">
                            {this.state.diagCodeErrorMsg}
                          </Alert>
                        </Stack>
                      </>
                    ) : null}
                    {(authorizationstatus &&
                      authorizationstatus == "4" &&
                      this.state.queuedInfo) ||
                      (authorizationstatus == "cancelled" &&
                        totalRows.length == 0 &&
                        errorsRow.length == 0) ? (
                      <>
                        <div
                          style={{
                            width: "100%",
                            margin: "auto",
                            paddingBottom: "20px",
                          }}
                        >
                          <TableContainer
                            component={Paper}
                            style={{
                              margin: "auto",
                              marginTop: "30px",
                              width: "100%",
                            }}
                          >
                            <Table aria-label="simple table">
                              <TableHead style={{ backgroundColor: "#fafafa" }}>
                                <TableRow style={{ textAlign: "center" }}>
                                  <TableCell align="center">Outcome</TableCell>
                                  <TableCell align="center">
                                    Bundle ID
                                  </TableCell>
                                  <TableCell align="center">
                                    Request Identifier
                                  </TableCell>
                                  <TableCell align="center">
                                    Pre Auth Response Identifier
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell
                                    align="center"
                                    style={{ fontSize: "small" }}
                                  >
                                    {this.state.queuedInfo.outcome}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{ fontSize: "small" }}
                                  >
                                    The Pre-Authorization for the selected
                                    activities is qeued , try to pull the
                                    response anothertime ,and the bundle ID is
                                    {this.state.queuedInfo.bundleID}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{ fontSize: "small" }}
                                  >
                                    {this.state.queuedInfo.requestIdentifier}
                                  </TableCell>

                                  <TableCell
                                    align="center"
                                    style={{ fontSize: "small" }}
                                  >
                                    {
                                      this.state.queuedInfo
                                        .preAuthResponseIdentifier
                                    }
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </>
                    ) : null}
                    {this.state.resubmissionFlag ? (
                      <Modal
                        open={this.state.resubmissionFlag}
                        onClose={this.handleCloseResubmission}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box
                          sx={style}
                          style={{
                            width: "90%",
                            height: "550px",
                            overflowY: "scroll",
                          }}
                        >
                          {allproceduresRows && allproceduresRows.length > 0 ? (
                            <>
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                                style={{
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                Select procedures for approval
                              </Typography>
                              <div style={{ width: "100%", margin: "auto" }}>
                                <TableContainer
                                  component={Paper}
                                  style={{ marginTop: "10px", width: "100%" }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow style={{ textAlign: "center" }}>
                                        {this.state.resubmissionFlag ? (
                                          <TableCell
                                            align="center"
                                            style={{ fontSize: "small" }}
                                          >
                                            <Checkbox
                                              name="selectAllProcedure"
                                              onChange={(e) =>
                                                this.handleCheckBox(e)
                                              }
                                            />{" "}
                                          </TableCell>
                                        ) : null}
                                        <TableCell align="center">
                                          Type
                                        </TableCell>
                                        <TableCell align="center">
                                          Code
                                        </TableCell>
                                        <TableCell align="center">
                                          Description
                                        </TableCell>
                                        <TableCell align="center">
                                          Quantity
                                        </TableCell>

                                        {this.state.showToothNumber ? (
                                          <TableCell align="center">
                                            Tooth Number
                                          </TableCell>
                                        ) : null}
                                        <TableCell align="center">
                                          Unit Price
                                        </TableCell>
                                        <TableCell align="center">
                                          Discount(%)
                                        </TableCell>
                                        <TableCell align="center">
                                          Tax
                                        </TableCell>
                                        <TableCell align="center">
                                          Deduction(%)
                                        </TableCell>

                                        <TableCell align="center">
                                          Patient Share
                                        </TableCell>
                                        <TableCell align="center">
                                          Net
                                        </TableCell>
                                        <TableCell align="center">
                                          Tooth
                                        </TableCell>
                                        <TableCell align="center">
                                          Related Diagnosis
                                        </TableCell>

                                        <TableCell align="center">
                                          Related Information Sequence
                                        </TableCell>

                                        {authorizationstatus &&
                                          authorizationstatus == "3" ? (
                                          <TableCell align="center">
                                            Adjucation Outcome
                                          </TableCell>
                                        ) : null}

                                        {authorizationstatus == "3" &&
                                          (adjucationoutcome == "rejected" ||
                                            adjucationoutcome == "partial") ? (
                                          <TableCell align="center">
                                            Rejection Reason
                                          </TableCell>
                                        ) : null}

                                        {authorizationstatus &&
                                          authorizationstatus == "3" &&
                                          (adjucationoutcome == "rejected" ||
                                            adjucationoutcome == "partial") ? (
                                          <TableCell align="center">
                                            Denail Code
                                          </TableCell>
                                        ) : null}

                                        {authorizationstatus &&
                                          authorizationstatus == "3" ? (
                                          <TableCell align="center">
                                            Adjucations
                                          </TableCell>
                                        ) : null}
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>{allproceduresRows}</TableBody>
                                  </Table>
                                </TableContainer>
                              </div>
                            </>
                          ) : null}
                          <div
                            style={{
                              textAlign: "center",
                              margin: "20px 0",
                            }}
                          >
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120)",
                                border: "1px ridge gray",

                                color: "white",
                                fontSize: "smaller",
                                margin: "auto",
                                transition: "background-color 0.4s, color 0.4s",
                              }}
                              onClick={(e) => {
                                if (this.state.idForReResubmission) {
                                  // if (AllAprovalForResubmission && AllAprovalForResubmission.length > 0) {
                                  //   visitNeedApproval["PrevRelated"] = AllAprovalForResubmission[AllAprovalForResubmission.length - 1]["authorizationrequestidentifier"]
                                  //   this.ReAuthorizationRequest(
                                  //     e,
                                  //     visitNeedApproval,
                                  //     this.state.idForReResubmission
                                  //   )

                                  // }else{
                                  console.log("here");
                                  this.ReAuthorizationRequest(
                                    e,
                                    visitNeedApproval,
                                    this.state.idForReResubmission
                                  );
                                  // }
                                } else {
                                  if (
                                    AllAprovalForResubmission &&
                                    AllAprovalForResubmission.length > 0
                                  ) {
                                    visitNeedApproval["PrevRelated"] =
                                      AllAprovalForResubmission[
                                      AllAprovalForResubmission.length - 1
                                      ]["authorizationrequestidentifier"];
                                    this.ReAuthorizationRequest(
                                      e,
                                      visitNeedApproval,
                                      ""
                                    );
                                  } else {
                                    this.ReAuthorizationRequest(
                                      e,
                                      visitNeedApproval,
                                      ""
                                    );
                                  }
                                }
                              }}
                            >
                              {this.state.resubmissionLoading
                                ? "Loading..."
                                : " Resubmission"}
                            </Button>
                          </div>
                        </Box>
                      </Modal>
                    ) : null}
                    {AllAprovalForResubmission &&
                      AllAprovalForResubmission.length > 0 ? (
                      <>
                        {AllAprovalForResubmission.map((element, index) => {
                          let resumissionTotalNet = 0;

                          return (
                            <Accordion
                              eventKey="0"
                              style={{
                                margin: "20px auto",
                                paddingBottom: "20px",
                                width: "100%",
                              }}
                            >
                              <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                  <span style={{ color: "grey" }}>
                                    Resubmission Info ({index + 1})
                                  </span>
                                </Accordion.Header>
                                <Accordion.Body>
                                  <div
                                    style={{
                                      boxShadow: "1px solid grey",
                                      padding: "15px",
                                      boxShadow:
                                        "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                                      borderRadius: "10px",
                                      marginBottom: "30px",
                                      width: "100%",
                                    }}
                                  >
                                    <Row>
                                      <Col xs={4}>
                                        {element.related ? (
                                          <div>
                                            <label
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Related To:
                                            </label>
                                            {element.related}
                                          </div>
                                        ) : null}
                                      </Col>
                                      <Col xs={4}>
                                        {element.authorizationresponseoutcome ===
                                          "error" ? (
                                          <div>
                                            <label
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Pre-Auth Status:{" "}
                                            </label>
                                            Faild
                                          </div>
                                        ) : element.authorizationresponseoutcome ===
                                          "queued" ? (
                                          <div>
                                            <label
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Pre-Auth Status:{" "}
                                            </label>
                                            Queued
                                          </div>
                                        ) : element.authorizationresponseoutcome ===
                                          "complete" ? (
                                          <div>
                                            <label
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Pre-Auth Status:{" "}
                                            </label>
                                            Complete
                                          </div>
                                        ) : element.authorizationresponseoutcome ===
                                          "cancelled" ? (
                                          <div>
                                            <label
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Pre-Auth Status:{" "}
                                            </label>
                                            Cancelled
                                          </div>
                                        ) : null}

                                        {element.authorizationrequestbundleid ? (
                                          <div>
                                            <label
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Pre-Auth Request ID:
                                            </label>
                                            {
                                              element.authorizationrequestbundleid
                                            }
                                          </div>
                                        ) : null}

                                        {element.authorizationrequestidentifier ? (
                                          <div>
                                            <label
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Pre-Auth Request Identifier:{" "}
                                            </label>
                                            {
                                              element.authorizationrequestidentifier
                                            }
                                          </div>
                                        ) : null}
                                      </Col>

                                      <Col xs={4}>
                                        {element.adjucationoutcome ? (
                                          <div
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            <label
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Pre-Auth Adjudication Outcome:{" "}
                                            </label>
                                            {element.adjucationoutcome}
                                          </div>
                                        ) : null}

                                        {element.authorizationresponseidentifier ? (
                                          <div>
                                            <label
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Pre-Auth Response Identifier:{" "}
                                            </label>
                                            {
                                              element.authorizationresponseidentifier
                                            }
                                          </div>
                                        ) : null}

                                        {element.preauthref ? (
                                          <div>
                                            <label
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Pre-Auth Reference(Approval
                                              Number):{" "}
                                            </label>
                                            {element.preauthref}
                                          </div>
                                        ) : null}
                                      </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                      <Col xs={6}>
                                        {element.diagnosis &&
                                          element.diagnosis.length > 0 ? (
                                          <div
                                            style={{
                                              margin: "auto",
                                              width: "80%",
                                            }}
                                          >
                                            <TableContainer
                                              component={Paper}
                                              style={{ marginTop: "10px" }}
                                            >
                                              <Table aria-label="simple table">
                                                <TableHead
                                                  style={{
                                                    backgroundColor: "#fafafa",
                                                  }}
                                                >
                                                  <TableRow>
                                                    <TableCell
                                                      align="center"
                                                      colSpan={4}
                                                    >
                                                      Diagnosis
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <TableCell align="center">
                                                      ID
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Type
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Code
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Description
                                                    </TableCell>
                                                  </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                  {element.diagnosis.map(
                                                    (ele, index) => {
                                                      return (
                                                        <>
                                                          <TableRow key={index}>
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {index + 1}{" "}
                                                            </TableCell>
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {ele.type}{" "}
                                                            </TableCell>

                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {ele.code}{" "}
                                                            </TableCell>

                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {ele.description}{" "}
                                                            </TableCell>
                                                          </TableRow>
                                                        </>
                                                      );
                                                    }
                                                  )}
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </div>
                                        ) : null}
                                      </Col>
                                      <Col xs={6}>
                                        {element.supportinginformation &&
                                          element.supportinginformation.length >
                                          0 ? (
                                          <>
                                            <div style={{ margin: "auto" }}>
                                              <TableContainer
                                                component={Paper}
                                                style={{
                                                  marginTop: "10px",
                                                  width: "80%",
                                                }}
                                              >
                                                <Table aria-label="simple table">
                                                  <TableHead
                                                    style={{
                                                      backgroundColor:
                                                        "#fafafa",
                                                    }}
                                                  >
                                                    <TableRow>
                                                      <TableCell
                                                        align="center"
                                                        colSpan={4}
                                                      >
                                                        Supporting Information
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <TableCell align="center">
                                                        ID
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        Information
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        Value
                                                      </TableCell>
                                                    </TableRow>
                                                  </TableHead>

                                                  <TableBody>
                                                    {element.supportinginformation.map(
                                                      (info, index) => {
                                                        let keys =
                                                          Object.keys(info);
                                                        let value;

                                                        if (
                                                          keys[0] ==
                                                          "chief-complaint"
                                                        ) {
                                                          value =
                                                            info[keys[0]][
                                                            "text"
                                                            ];
                                                        } else if (
                                                          keys[0] ==
                                                          "attachment"
                                                        ) {
                                                          value =
                                                            info[keys[0]][
                                                            "title"
                                                            ];
                                                        } else {
                                                          value =
                                                            info[[keys[0]]];
                                                        }
                                                        return (
                                                          <>
                                                            <TableRow
                                                              key={index}
                                                            >
                                                              <TableCell
                                                                align="center"
                                                                style={{
                                                                  fontSize:
                                                                    "small",
                                                                }}
                                                              >
                                                                {index + 1}{" "}
                                                              </TableCell>
                                                              <TableCell
                                                                align="center"
                                                                style={{
                                                                  fontSize:
                                                                    "small",
                                                                }}
                                                              >
                                                                {keys[0]}
                                                              </TableCell>

                                                              <TableCell
                                                                align="center"
                                                                style={{
                                                                  fontSize:
                                                                    "small",
                                                                  textTransform:
                                                                    "capitalize",
                                                                }}
                                                              >
                                                                {value}
                                                              </TableCell>
                                                            </TableRow>
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                  </TableBody>
                                                </Table>
                                              </TableContainer>
                                            </div>
                                          </>
                                        ) : null}
                                      </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                      {element.allprocedures &&
                                        element.allprocedures.length > 0 ? (
                                        <>
                                          <div
                                            style={{
                                              width: "100%",
                                              margin: "auto",
                                            }}
                                          >
                                            <TableContainer
                                              component={Paper}
                                              style={{
                                                marginTop: "10px",
                                                width: "100%",
                                              }}
                                            >
                                              <Table aria-label="simple table">
                                                <TableHead
                                                  style={{
                                                    backgroundColor: "#fafafa",
                                                  }}
                                                >
                                                  <TableRow
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <TableCell align="center">
                                                      Type
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Code
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Description
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Quantity
                                                    </TableCell>

                                                    <TableCell align="center">
                                                      Unit Price
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Discount(%)
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Tax
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Deduction(%)
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Patient Share
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Net
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Tooth
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Related Diagnosis
                                                    </TableCell>

                                                    <TableCell align="center">
                                                      Related Information
                                                      Sequence
                                                    </TableCell>

                                                    {element.authorizationresponseoutcome ===
                                                      "complete" ? (
                                                      <TableCell align="center">
                                                        Adjucation Outcome
                                                      </TableCell>
                                                    ) : null}

                                                    {element.authorizationresponseoutcome ===
                                                      "complete" &&
                                                      (element.adjucationoutcome ==
                                                        "rejected" ||
                                                        element.adjucationoutcome ==
                                                        "partial") ? (
                                                      <TableCell align="center">
                                                        Rejection Reason
                                                      </TableCell>
                                                    ) : null}

                                                    {element.authorizationresponseoutcome ===
                                                      "complete" &&
                                                      (element.adjucationoutcome ==
                                                        "rejected" ||
                                                        element.adjucationoutcome ==
                                                        "partial") ? (
                                                      <TableCell align="center">
                                                        Denail Code
                                                      </TableCell>
                                                    ) : null}

                                                    {element.authorizationresponseoutcome ===
                                                      "complete" ? (
                                                      <TableCell align="center">
                                                        Adjucations
                                                      </TableCell>
                                                    ) : null}
                                                  </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                  {element.allprocedures.map(
                                                    (ele, index) => {
                                                      resumissionTotalNet +=
                                                        parseFloat(ele.net);

                                                      return (
                                                        <TableRow>
                                                          <TableCell
                                                            align="center"
                                                            style={{
                                                              fontSize: "small",
                                                              textTransform:
                                                                "capitalize",
                                                            }}
                                                          >
                                                            {ele.type}{" "}
                                                          </TableCell>
                                                          <TableCell
                                                            align="center"
                                                            style={{
                                                              fontSize: "small",
                                                            }}
                                                          >
                                                            {ele.code}{" "}
                                                          </TableCell>
                                                          <TableCell
                                                            align="center"
                                                            style={{
                                                              fontSize: "small",
                                                              textTransform:
                                                                "capitalize",
                                                            }}
                                                          >
                                                            {ele.description}
                                                          </TableCell>
                                                          <TableCell
                                                            align="center"
                                                            style={{
                                                              fontSize: "small",
                                                            }}
                                                          >
                                                            {ele.quantity}
                                                          </TableCell>
                                                          <TableCell
                                                            align="center"
                                                            style={{
                                                              fontSize: "small",
                                                            }}
                                                          >
                                                            {ele.price}
                                                          </TableCell>
                                                          <TableCell
                                                            align="center"
                                                            style={{
                                                              fontSize: "small",
                                                            }}
                                                          >
                                                            {ele.discount}%
                                                          </TableCell>
                                                          <TableCell
                                                            align="center"
                                                            style={{
                                                              fontSize: "small",
                                                            }}
                                                          >
                                                            {ele.tax}
                                                          </TableCell>
                                                          <TableCell
                                                            align="center"
                                                            style={{
                                                              fontSize: "small",
                                                            }}
                                                          >
                                                            {ele.deduction}%
                                                          </TableCell>
                                                          <TableCell
                                                            align="center"
                                                            style={{
                                                              fontSize: "small",
                                                            }}
                                                          >
                                                            {ele.patientshare}
                                                          </TableCell>
                                                          <TableCell
                                                            align="center"
                                                            style={{
                                                              fontSize: "small",
                                                            }}
                                                          >
                                                            {ele.net}
                                                          </TableCell>

                                                          {ele.type ==
                                                            "dental" &&
                                                            ele.toothNumber ? (
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {ele.toothNumber +
                                                                "/" +
                                                                ele.toothDescription}
                                                            </TableCell>
                                                          ) : (
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {" "}
                                                            </TableCell>
                                                          )}

                                                          {ele.diagnosisSequence &&
                                                            ele.diagnosisSequence
                                                              .length > 0 ? (
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {ele.diagnosisSequence.toString()}
                                                            </TableCell>
                                                          ) : (
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {" "}
                                                            </TableCell>
                                                          )}

                                                          {ele.informationSequence &&
                                                            ele
                                                              .informationSequence
                                                              .length > 0 ? (
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {ele.informationSequence.toString()}
                                                            </TableCell>
                                                          ) : (
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            ></TableCell>
                                                          )}

                                                          {element.authorizationresponseoutcome ===
                                                            "complete" ? (
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                                textTransform:
                                                                  "capitalize",
                                                              }}
                                                            >
                                                              {ele.outcome}
                                                            </TableCell>
                                                          ) : null}

                                                          {element.authorizationresponseoutcome ===
                                                            "complete" &&
                                                            (element.outcome ==
                                                              "rejected" ||
                                                              element.outcome ==
                                                              "partial") ? (
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                                textTransform:
                                                                  "capitalize",
                                                              }}
                                                            >
                                                              {ele.reason}
                                                            </TableCell>
                                                          ) : null}

                                                          {element.authorizationresponseoutcome ===
                                                            "complete" &&
                                                            (element.outcome ==
                                                              "rejected" ||
                                                              element.outcome ==
                                                              "partial") ? (
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {ele.denailCode}
                                                            </TableCell>
                                                          ) : null}

                                                          {element.authorizationresponseoutcome ===
                                                            "complete" ? (
                                                            <TableCell
                                                              align="center"
                                                              style={{
                                                                fontSize:
                                                                  "small",
                                                              }}
                                                            >
                                                              {ele.adjudications &&
                                                                ele.adjudications
                                                                  .length > 0
                                                                ? ele.adjudications.map(
                                                                  (
                                                                    adj,
                                                                    i
                                                                  ) => {
                                                                    return (
                                                                      <TableRow
                                                                        key={
                                                                          i
                                                                        }
                                                                      >
                                                                        <TableCell
                                                                          align="center"
                                                                          style={{
                                                                            fontSize:
                                                                              "small",
                                                                            textTransform:
                                                                              "capitalize",
                                                                          }}
                                                                        >
                                                                          {
                                                                            adj.category
                                                                          }
                                                                        </TableCell>{" "}
                                                                        <TableCell
                                                                          align="center"
                                                                          style={{
                                                                            fontSize:
                                                                              "small",
                                                                          }}
                                                                        >
                                                                          {
                                                                            adj.amount
                                                                          }
                                                                        </TableCell>
                                                                      </TableRow>
                                                                    );
                                                                  }
                                                                )
                                                                : null}
                                                            </TableCell>
                                                          ) : null}
                                                        </TableRow>
                                                      );
                                                    }
                                                  )}

                                                  <TableRow>
                                                    <TableCell colSpan={15}>
                                                      {" "}
                                                      Resubmission Total Net:
                                                      {parseFloat(
                                                        resumissionTotalNet
                                                      ).toFixed(2)}{" "}
                                                      SAR
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </div>
                                        </>
                                      ) : null}
                                    </Row>
                                    <hr />
                                    <Row>
                                      {element.authorizationresponseoutcome ===
                                        "error" &&
                                        element.errorsRow &&
                                        element.errorsRow.length > 0 ? (
                                        <>
                                          <Typography
                                            id="modal-modal-title"
                                            variant="h6"
                                            component="h2"
                                            style={{
                                              textAlign: "center",
                                              marginTop: "10px",
                                            }}
                                          >
                                            Errors
                                          </Typography>
                                          <div
                                            style={{
                                              width: "100%",
                                              margin: "auto",
                                              paddingBottom: "20px",
                                            }}
                                          >
                                            <TableContainer
                                              component={Paper}
                                              style={{
                                                margin: "auto",
                                                marginTop: "30px",
                                                width: "100%",
                                              }}
                                            >
                                              <Table aria-label="simple table">
                                                <TableHead
                                                  style={{
                                                    backgroundColor: "#fafafa",
                                                  }}
                                                >
                                                  <TableRow
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <TableCell align="center">
                                                      Error Code
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Error Display
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Error Extention
                                                    </TableCell>
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  {element.errorsRow}
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </div>
                                        </>
                                      ) : null}
                                      {element.authorizationresponseoutcome ===
                                        "queued" && element.queuedInfo ? (
                                        <>
                                          <div
                                            style={{
                                              width: "100%",
                                              margin: "auto",
                                              paddingBottom: "20px",
                                            }}
                                          >
                                            <TableContainer
                                              component={Paper}
                                              style={{
                                                margin: "auto",
                                                marginTop: "30px",
                                                width: "100%",
                                              }}
                                            >
                                              <Table aria-label="simple table">
                                                <TableHead
                                                  style={{
                                                    backgroundColor: "#fafafa",
                                                  }}
                                                >
                                                  <TableRow
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <TableCell align="center">
                                                      Outcome
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Bundle ID
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Request Identifier
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Pre Auth Response
                                                      Identifier
                                                    </TableCell>
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  <TableRow>
                                                    <TableCell
                                                      align="center"
                                                      style={{
                                                        fontSize: "small",
                                                      }}
                                                    >
                                                      {
                                                        element.queuedInfo
                                                          .outcome
                                                      }
                                                    </TableCell>
                                                    <TableCell
                                                      align="center"
                                                      style={{
                                                        fontSize: "small",
                                                      }}
                                                    >
                                                      The Pre-Authorization for
                                                      the selected activities is
                                                      qeued , try to pull the
                                                      response anothertime ,and
                                                      the bundle ID is
                                                      {
                                                        element.queuedInfo
                                                          .bundleID
                                                      }
                                                    </TableCell>
                                                    <TableCell
                                                      align="center"
                                                      style={{
                                                        fontSize: "small",
                                                      }}
                                                    >
                                                      {
                                                        element.queuedInfo
                                                          .requestIdentifier
                                                      }
                                                    </TableCell>

                                                    <TableCell
                                                      align="center"
                                                      style={{
                                                        fontSize: "small",
                                                      }}
                                                    >
                                                      {
                                                        element.queuedInfo
                                                          .preAuthResponseIdentifier
                                                      }
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </div>
                                        </>
                                      ) : null}
                                    </Row>
                                    <Row>
                                      {element.authorizationresponseoutcome ===
                                        "error" ? (
                                        <div style={{ textAlign: "right" }}>
                                          <Button
                                            variant="contained"
                                            style={{
                                              backgroundColor:
                                                "rgb(97 110 120)",
                                              border: "1px ridge gray",
                                              width: "25%",
                                              color: "white",
                                              fontSize: "smaller",
                                              transition:
                                                "background-color 0.4s, color 0.4s",
                                            }}
                                            onClick={(e) => {
                                              this.setState({
                                                resubmissionFlag: true,
                                                idForReResubmission: element.id,
                                                proceduresSeq: [],
                                                proceduresForResubmission: [],
                                              });
                                              this.getProcedures(element.id);
                                            }}
                                          >
                                            Re-resubmission
                                          </Button>
                                        </div>
                                      ) : null}
                                    </Row>
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          );
                        })}
                      </>
                    ) : null}
                  </Box>
                </Modal>
              ) : null}
            </div>
          </div>
        </div>
      </Box>
    );
  }
}

export default PreAuthorization;
